import React, { useEffect, useState } from "react";
import {
    Button, Form, Badge, Card, Spinner, Modal,
    Row, Col, Container, InputGroup, Table,
    OverlayTrigger, Popover, ButtonGroup
} from 'react-bootstrap';
import Menu from '../../comum/Menu/menu.jsx';
import { useNavigate } from "react-router-dom";
import Footer from '../../comum/Footer/index.jsx';
import { api } from '../../services/api.js';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { FaFileInvoice, FaClipboardList, FaFolderOpen, FaChartBar, FaPlus, FaCheck, FaTimes, FaCalendarAlt, FaFilePdf, FaPaperclip, FaTrash } from 'react-icons/fa';

const MySwal = withReactContent(Swal);

const LISTA_DEPARTAMENTOS = [
    "COMERCIAL", "CONTABILIDADE", "DAOP", "DEOS",
    "DIRETORIA", "FINANCEIRO", "JURIDICO", "LOGISTICA",
    "MARKETING", "MONITORAMENTO", "TI"
];

const normalizarObjeto = (obj) => {
    if (!obj || typeof obj !== 'object') return obj;
    const novoObj = {};
    Object.keys(obj).forEach(key => {
        novoObj[key.toUpperCase()] = obj[key];
    });
    return novoObj;
};

function FichaFinanceira() {
    const [loading, setLoading] = useState(false);
    const [contratos, setContratos] = useState([]);
    const [pendencias, setPendencias] = useState([]);
    const [todosLancamentos, setTodosLancamentos] = useState([]);
    const [historico12, setHistorico12] = useState([]);
    const [notasDoLancamento, setNotasDoLancamento] = useState([]);
    const [aprovacoesWorkflow, setAprovacoesWorkflow] = useState([]);
    const [anexosContratoSelecionado, setAnexosContratoSelecionado] = useState([]);
    const [anexosModalEdicao, setAnexosModalEdicao] = useState([]);
    const [filtroBusca, setFiltroBusca] = useState("");
    const [filtroDepto, setFiltroDepto] = useState("");
    const [diasSelecionados, setDiasSelecionados] = useState([]);
    const [abaAtiva, setAbaAtiva] = useState("PENDENCIAS");
    const [filtroStatusCentral, setFiltroStatusCentral] = useState("TODOS");

    const [showModalNovoContrato, setShowModalNovoContrato] = useState(false);
    const [showModalLancarCompetencia, setShowModalLancarCompetencia] = useState(false);
    const [showModalAprovar, setShowModalAprovar] = useState(false);
    const [showModalPDF, setShowModalPDF] = useState(false);
    const [showModalLogs, setShowModalLogs] = useState(false);
    const [showModalNovoAnexo, setShowModalNovoAnexo] = useState(false);

    // Modal de Histórico de Lançamentos do Contrato
    const [showModalHistoricoCompleto, setShowModalHistoricoCompleto] = useState(false);
    const [listaLancamentosContrato, setListaLancamentosContrato] = useState([]);
    const [lancamentoAtivoVisao, setLancamentoAtivoVisao] = useState(null);

    const [urlPdfView, setUrlPdfView] = useState("");
    const [tituloPdfView, setTituloPdfView] = useState("");
    const [logsContrato, setLogsContrato] = useState([]);

    const chapa = localStorage.getItem("chapa");
    const usuarioLogado = localStorage.getItem("usuario_matricula") || localStorage.getItem("chapa") || "";
    const navigate = useNavigate();

    useEffect(() => {
        const usuario = localStorage.getItem("chapa");
        const permiteFichaFinanceira = localStorage.getItem("FICHAFINANCEIRA");
        if (!usuario) { navigate("/arbor/login"); return; }
        if (permiteFichaFinanceira !== "S") {
            Swal.fire({
                icon: 'error',
                title: 'Acesso Negado',
                text: 'Você não tem permissão para acessar o módulo de Ficha Financeira.',
                confirmButtonText: 'OK'
            }).then(() => { navigate("/arbor/home"); });
        }
    }, [navigate]);

    const [isEdicaoContrato, setIsEdicaoContrato] = useState(false);
    const [formContrato, setFormContrato] = useState({
        finc_id: 0,
        finc_descricao: "",
        finc_fornecedor: "",
        finc_departamento: "TI",
        finc_tipo_abrangencia: "FILIAL",
        finc_cod_emp: 1,
        finc_data_inicio: "",
        tempo_meses: 24,
        finc_data_fim: "",
        finc_data_celebracao: "",
        finc_indice_reajuste: "IGPM",
        finc_dia_vencimento: 10,
        finc_valor_base: "R$ 0,00",
        finc_nome_arq: "",
        arq_contrato: null
    });

    const [formAnexo, setFormAnexo] = useState({
        finc_id: 0,
        fina_tipo: "ADENDO",
        fina_descricao: "",
        arq_anexo: null
    });

    const [alcadas, setAlcadas] = useState([
        { matricula: "", nome: "", cargo: "GERENTE DE SETOR" },
        { matricula: "", nome: "", cargo: "DIRETOR" }
    ]);

    const [contratoSelecionado, setContratoSelecionado] = useState(null);
    const [formLancamento, setFormLancamento] = useState({
        finl_competencia: "",
        finl_valor_total: "R$ 0,00",
        finl_valor_anterior: 0,
        finl_observacao: "",
        notas: []
    });

    const [lancamentoPendSelecionado, setLancamentoPendSelecionado] = useState(null);
    const [obsAprovacao, setObsAprovacao] = useState("");
    const [chapaOutroAutorizador, setChapaOutroAutorizador] = useState("");

    const renderStatusLembrete = (contrato) => {
        if (!contrato) return null;

        const getVal = (key) => {
            const kUpper = key.toUpperCase();
            const kLower = key.toLowerCase();
            if (contrato[kUpper] !== undefined && contrato[kUpper] !== null) return contrato[kUpper];
            if (contrato[kLower] !== undefined && contrato[kLower] !== null) return contrato[kLower];
            return '';
        };

        const rawStatus = String(getVal('ULT_STATUS_LANCADO')).trim().toUpperCase();

        const normalizarComp = (val) => {
            if (!val) return '';
            const numOnly = String(val).replace(/\D/g, '');
            if (numOnly.length === 6) return `${numOnly.substring(0, 2)}/${numOnly.substring(2)}`;
            if (numOnly.length === 4) return `${numOnly.substring(0, 2)}/20${numOnly.substring(2)}`;
            return String(val).trim();
        };

        const compAtual = normalizarComp(getVal('COMP_ATUAL'));
        const ultComp = normalizarComp(getVal('ULT_COMP_LANCADA'));

        const diaVenc = Number(getVal('FINC_DIA_VENCIMENTO')) || 10;
        const hoje = new Date();
        const diaAtual = hoje.getDate();
        const mesAtual = hoje.getMonth();
        const anoAtual = hoje.getFullYear();

        let dataVenc = new Date(anoAtual, mesAtual, diaVenc);
        if (diaAtual > diaVenc) {
            dataVenc = new Date(anoAtual, mesAtual + 1, diaVenc);
        }

        const diffTime = dataVenc - hoje;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

        const mesmoMes = Boolean(ultComp && compAtual && ultComp === compAtual);

        if (mesmoMes || (ultComp && rawStatus === 'APROVADO')) {
            if (rawStatus === 'APROVADO') {
                return (
                    <Badge bg="success-subtle" text="success" className="p-2 border border-success-subtle rounded-2 fw-bold d-inline-flex align-items-center gap-1">
                        <FaCheck size={11} /> Lançado e Aprovado
                    </Badge>
                );
            }
            if (rawStatus === 'NEGADO' || rawStatus === 'REJEITADO') {
                return (
                    <Badge bg="danger-subtle" text="danger" className="p-2 border border-danger-subtle rounded-2 fw-bold d-inline-flex align-items-center gap-1">
                        <FaTimes size={11} /> Recusado / Devolvido
                    </Badge>
                );
            }
            return (
                <Badge bg="warning-subtle" text="warning-emphasis" className="p-2 border border-warning-subtle rounded-2 fw-bold">
                    ⏳ Pendente Aprovação
                </Badge>
            );
        }

        if (diffDays <= 0) {
            return (
                <Badge bg="danger" className="p-2 rounded-2 text-white fw-bold">
                    ⚠️ Vence Hoje / Atrasado
                </Badge>
            );
        }
        if (diffDays <= 7) {
            return (
                <Badge bg="warning" text="dark" className="p-2 rounded-2 fw-bold">
                    ⏰ Vence em {diffDays} dia(s)
                </Badge>
            );
        }

        return (
            <Badge bg="secondary-subtle" text="secondary" className="p-2 border border-secondary-subtle rounded-2 fw-semibold">
                Próx. Vencimento: {diffDays}d
            </Badge>
        );
    };

    const calcularDataFim = (dataInicioStr, meses) => {
        if (!dataInicioStr || !meses || isNaN(meses) || Number(meses) <= 0) return "";
        const parts = dataInicioStr.split("-");
        if (parts.length !== 3) return "";

        const ano = parseInt(parts[0], 10);
        const mes = parseInt(parts[1], 10) - 1;
        const dia = parseInt(parts[2], 10);

        const dt = new Date(ano, mes, dia);
        dt.setMonth(dt.getMonth() + parseInt(meses, 10));

        const yyyy = dt.getFullYear();
        const mm = String(dt.getMonth() + 1).padStart(2, '0');
        const dd = String(dt.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
    };

    const calcularMesesEntreDatas = (dtIniStr, dtFimStr) => {
        if (!dtIniStr || !dtFimStr) return 24;
        const d1 = new Date(dtIniStr);
        const d2 = new Date(dtFimStr);
        if (isNaN(d1.getTime()) || isNaN(d2.getTime())) return 24;
        const meses = (d2.getFullYear() - d1.getFullYear()) * 12 + (d2.getMonth() - d1.getMonth());
        return meses > 0 ? meses : 24;
    };

    const formatarMoedaBR = (valor) => {
        const num = Number(valor) || 0;
        return num.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    };

    const aplicarMascaraMoeda = (valorStr) => {
        const apenasDigitos = String(valorStr).replace(/\D/g, "");
        if (!apenasDigitos) return "R$ 0,00";
        const numero = Number(apenasDigitos) / 100;
        return numero.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    };

    const parseMoedaParaNumero = (moedaStr) => {
        if (!moedaStr) return 0;
        const limpo = String(moedaStr)
            .replace("R$", "")
            .replace(/\s/g, "")
            .replace(/\./g, "")
            .replace(",", ".");
        return parseFloat(limpo) || 0;
    };

    const convertFileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            if (!file) { resolve(""); return; }
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const res = reader.result;
                resolve(typeof res === 'string' ? res.split(',')[1] || res : "");
            };
            reader.onerror = (err) => reject(err);
        });
    };

    useEffect(() => {
        if (!chapa) {
            navigate("/arbor/login");
            return;
        }
        carregarPendencias();
        carregarContratos();
    }, []);

    const carregarContratos = async () => {
        try {
            const strDias = diasSelecionados.join(",");
            const res = await api.get(`/financeiro/contratos?busca=${encodeURIComponent(filtroBusca)}&dias_vencimento=${encodeURIComponent(strDias)}&departamento=${encodeURIComponent(filtroDepto)}`);
            const listaRaw = Array.isArray(res.data) ? res.data : [];

            setContratos(listaRaw.map(item => normalizarObjeto(item)));
        } catch (err) {
            toast.error("Erro ao carregar lista de contratos.");
        }
    };

    const toggleDiaFiltro = (dia) => {
        let novosDias = [];
        if (diasSelecionados.includes(dia)) {
            novosDias = diasSelecionados.filter(d => d !== dia);
        } else {
            novosDias = [...diasSelecionados, dia].sort((a, b) => a - b);
        }
        setDiasSelecionados(novosDias);
    };

    const carregarPendencias = async () => {
        setLoading(true);
        try {
            const res = await api.get(`/financeiro/pendencias/${usuarioLogado}`);
            const listaRaw = Array.isArray(res.data) ? res.data : [];
            setPendencias(listaRaw.map(item => normalizarObjeto(item)));
        } catch (err) {
            toast.error("Erro ao carregar pendências de aprovação.");
        } finally {
            setLoading(false);
        }
    };

    const carregarTodosLancamentos = async () => {
        setLoading(true);
        try {
            const res = await api.get('/financeiro/lancamentos/status-geral');
            const listaRaw = Array.isArray(res.data) ? res.data : [];
            const listaNormalizada = listaRaw.map(item => normalizarObjeto(item));

            const listaComNomes = await Promise.all(
                listaNormalizada.map(async (item) => {
                    let nomeAprovador = item.NOME_APROVADOR_ATUAL || "";
                    let nomeLancador = "";
                    const chapaAtual = item.CHAPA_APROVADOR_ATUAL;
                    const chapaLancador = item.USUARIO_LANCAMENTO;

                    if (!nomeAprovador && chapaAtual) {
                        try {
                            const resUsr = await api.get(`/usuario/dados/${chapaAtual}`);
                            const dUsr = Array.isArray(resUsr.data) ? resUsr.data[0] : resUsr.data;
                            if (dUsr) nomeAprovador = dUsr.nome;
                        } catch (e) { }
                    }

                    if (chapaLancador) {
                        try {
                            const resLanc = await api.get(`/usuario/dados/${chapaLancador}`);
                            const dLanc = Array.isArray(resLanc.data) ? resLanc.data[0] : resLanc.data;
                            if (dLanc) nomeLancador = dLanc.nome;
                        } catch (e) { }
                    }

                    return {
                        ...item,
                        NOME_APROVADOR_ATUAL: nomeAprovador,
                        NOME_LANCADOR: nomeLancador
                    };
                })
            );

            setTodosLancamentos(listaComNomes);
        } catch (err) {
            toast.error("Erro ao carregar central de lançamentos.");
        } finally {
            setLoading(false);
        }
    };

    const carregarHistorico12Meses = async (fincId) => {
        try {
            const res = await api.get(`/financeiro/historico/${fincId}`);
            const listaRaw = Array.isArray(res.data) ? res.data : [];
            const normalizados = listaRaw.map(item => normalizarObjeto(item));
            setHistorico12(normalizados);
            return normalizados;
        } catch (err) {
            toast.error("Erro ao carregar histórico das 12 últimas competências.");
            return [];
        }
    };

    const carregarNotasDoLancamento = async (finlId) => {
        try {
            const res = await api.get(`/financeiro/lancamento/${finlId}/notas`);
            const listaRaw = Array.isArray(res.data) ? res.data : [];
            setNotasDoLancamento(listaRaw.map(item => normalizarObjeto(item)));
        } catch (err) {
            toast.error("Erro ao carregar notas fiscais da competência.");
        }
    };

    const carregarAnexosDoContrato = async (fincId) => {
        try {
            const res = await api.get(`/financeiro/contrato/${fincId}/anexos`);
            const listaRaw = Array.isArray(res.data) ? res.data : [];
            setAnexosContratoSelecionado(listaRaw.map(item => normalizarObjeto(item)));
        } catch (err) {
            toast.error("Erro ao carregar anexos/adendos do contrato.");
        }
    };

    const carregarWorkflowAprovacoes = async (finlId) => {
        try {
            const res = await api.get(`/financeiro/lancamento/${finlId}/aprovacoes`);
            const listaRaw = Array.isArray(res.data) ? res.data : [];
            const listaNormalizada = listaRaw.map(item => normalizarObjeto(item));

            const listaComNomes = await Promise.all(
                listaNormalizada.map(async (item) => {
                    let nome = "";
                    const mat = item.FINA_MATRICULA || item.FINP_MATRICULA || "";

                    if (mat) {
                        try {
                            const resUsr = await api.get(`/usuario/dados/${mat}`);
                            const dUsr = Array.isArray(resUsr.data) ? resUsr.data[0] : resUsr.data;
                            if (dUsr) nome = dUsr.nome;
                        } catch (e) { }
                    }
                    return { ...item, NOME_COLABORADOR: nome, MATRICULA_CORRETA: mat };
                })
            );

            setAprovacoesWorkflow(listaComNomes);
        } catch (err) {
            toast.error("Erro ao carregar o workflow de aprovações.");
        }
    };

    const handleAbrirHistoricoCompleto = async (fincId, e) => {
        if (e && e.stopPropagation) e.stopPropagation();

        const idNumeric = Number(fincId) || 0;
        if (!idNumeric) {
            toast.warning("Identificador do contrato inválido.");
            return;
        }

        setLoading(true);
        try {
            let listaLancamentos = [];

            try {
                const resLanc = await api.get(`financeiro/lancamentos-completo/${idNumeric}`);
                listaLancamentos = Array.isArray(resLanc.data) ? resLanc.data.map(item => normalizarObjeto(item)) : [];
            } catch (errLanc) {
                const resHist = await carregarHistorico12Meses(idNumeric);
                listaLancamentos = resHist || [];
            }

            await carregarAnexosDoContrato(idNumeric).catch(err => console.error("Erro anexos:", err));

            setListaLancamentosContrato(listaLancamentos);

            if (listaLancamentos.length > 0) {
                const primeiro = listaLancamentos[0];
                setLancamentoAtivoVisao(primeiro);
                await Promise.all([
                    carregarNotasDoLancamento(primeiro.FINL_ID),
                    carregarWorkflowAprovacoes(primeiro.FINL_ID)
                ]).catch(err => console.error("Erro detalhes lançamento:", err));
            } else {
                setLancamentoAtivoVisao(null);
                setNotasDoLancamento([]);
                setAprovacoesWorkflow([]);
            }

            setShowModalHistoricoCompleto(true);
        } catch (err) {
            console.error("Erro no handleAbrirHistoricoCompleto:", err);
            toast.error("Erro ao abrir a tela de lançamentos.");
        } finally {
            setLoading(false);
        }
    };

    const handleTrocarCompetenciaVisao = async (itemLanc) => {
        setLoading(true);
        try {
            setLancamentoAtivoVisao(itemLanc);
            await Promise.all([
                carregarNotasDoLancamento(itemLanc.FINL_ID),
                carregarWorkflowAprovacoes(itemLanc.FINL_ID)
            ]);
        } catch (err) {
            toast.error("Erro ao carregar os dados da competência selecionada.");
        } finally {
            setLoading(false);
        }
    };

    const handleBuscarAprovador = async (index, chapaColab) => {
        const chapaLimpa = String(chapaColab || "").trim();
        if (!chapaLimpa) return;

        try {
            const res = await api.get(`/usuario/dados/${chapaLimpa}`);
            const dados = Array.isArray(res.data) ? res.data[0] : res.data;

            if (dados && (dados.codsituacao === 'A' || dados.codsituacao === 'F')) {
                const novasAlcadas = [...alcadas];
                novasAlcadas[index].nome = dados.nome;
                if (!novasAlcadas[index].cargo && dados.funcao) {
                    novasAlcadas[index].cargo = dados.funcao;
                }
                setAlcadas(novasAlcadas);
                toast.success(`Aprovador vinculado: ${dados.nome}`);
            } else {
                toast.warning(`Colaborador ${chapaLimpa} não está elegível para assinatura.`);
                const novasAlcadas = [...alcadas];
                novasAlcadas[index].nome = "";
                setAlcadas(novasAlcadas);
            }
        } catch (err) {
            toast.error("Erro ao buscar dados do colaborador pela chapa.");
            const novasAlcadas = [...alcadas];
            novasAlcadas[index].nome = "";
            setAlcadas(novasAlcadas);
        }
    };

    const handleAdicionarAlcada = () => {
        setAlcadas([...alcadas, { matricula: "", nome: "", cargo: "" }]);
    };

    const handleRemoverAlcada = (index) => {
        if (alcadas.length === 1) {
            toast.warning("O contrato deve conter ao menos 1 alçada de assinatura.");
            return;
        }
        setAlcadas(alcadas.filter((_, i) => i !== index));
    };

    const handleAbrirEditarContrato = async (fincId) => {
        setLoading(true);
        setIsEdicaoContrato(true);
        try {
            const res = await api.get(`/financeiro/contrato/${fincId}`);
            const dados = normalizarObjeto(res.data);

            const dtIni = dados.DT_INI_STR || "";
            const dtFim = dados.DT_FIM_STR || "";
            const mesesCalc = calcularMesesEntreDatas(dtIni, dtFim);

            setFormContrato({
                finc_id: dados.FINC_ID || 0,
                finc_descricao: dados.FINC_DESCRICAO || "",
                finc_fornecedor: dados.FINC_FORNECEDOR || "",
                finc_departamento: dados.FINC_DEPARTAMENTO || "TI",
                finc_tipo_abrangencia: dados.FINC_TIPO_ABRANGENCIA || "FILIAL",
                finc_cod_emp: dados.FINC_COD_EMP || 1,
                finc_data_inicio: dtIni,
                tempo_meses: mesesCalc,
                finc_data_fim: dtFim,
                finc_data_celebracao: dados.DT_CEL_STR || "",
                finc_indice_reajuste: dados.FINC_INDICE_REAJUSTE || "IGPM",
                finc_dia_vencimento: dados.FINC_DIA_VENCIMENTO || 10,
                finc_valor_base: formatarMoedaBR(dados.FINC_VALOR_BASE),
                finc_nome_arq: dados.FINC_NOME_ARQ || "",
                arq_contrato: null
            });

            const listaAnexos = Array.isArray(dados.ANEXOS || dados.anexos) ? (dados.ANEXOS || dados.anexos) : [];
            setAnexosModalEdicao(listaAnexos.map(item => normalizarObjeto(item)));

            const alcadasList = Array.isArray(dados.ALCADAS || dados.alcadas) ? (dados.ALCADAS || dados.alcadas) : [];
            const alcadasComNome = await Promise.all(
                alcadasList.map(async (alcRaw) => {
                    const alc = normalizarObjeto(alcRaw);
                    const mat = alc.FINA_MATRICULA;
                    let nomeColab = "";
                    if (mat) {
                        try {
                            const resUsr = await api.get(`/usuario/dados/${mat}`);
                            const dUsr = Array.isArray(resUsr.data) ? resUsr.data[0] : resUsr.data;
                            if (dUsr) nomeColab = dUsr.nome;
                        } catch (e) { }
                    }
                    return {
                        matricula: mat,
                        nome: nomeColab,
                        cargo: alc.FINA_CARGO
                    };
                })
            );

            setAlcadas(alcadasComNome.length > 0 ? alcadasComNome : [{ matricula: "", nome: "", cargo: "" }]);
            setShowModalNovoContrato(true);
        } catch (err) {
            toast.error("Erro ao carregar dados do contrato.");
        } finally {
            setLoading(false);
        }
    };

    const handleNovoContratoModal = () => {
        setIsEdicaoContrato(false);
        setAnexosModalEdicao([]);
        setFormContrato({
            finc_id: 0,
            finc_descricao: "",
            finc_fornecedor: "",
            finc_departamento: "TI",
            finc_tipo_abrangencia: "FILIAL",
            finc_cod_emp: 1,
            finc_data_inicio: "",
            tempo_meses: 24,
            finc_data_fim: "",
            finc_data_celebracao: "",
            finc_indice_reajuste: "IGPM",
            finc_dia_vencimento: 10,
            finc_valor_base: "R$ 0,00",
            finc_nome_arq: "",
            arq_contrato: null
        });
        setAlcadas([
            { matricula: "", nome: "", cargo: "GERENTE DE SETOR" },
            { matricula: "", nome: "", cargo: "DIRETOR" }
        ]);
        setShowModalNovoContrato(true);
    };

    const handleSalvarContrato = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            let base64Contrato = "";
            let nomeContrato = "";
            if (formContrato.arq_contrato) {
                base64Contrato = await convertFileToBase64(formContrato.arq_contrato);
                nomeContrato = formContrato.arq_contrato.name;
            }

            const tipoAbrangencia = formContrato.finc_tipo_abrangencia.includes("GLOBAL") ? "GLOBAL" : "FILIAL";

            const payload = {
                ...formContrato,
                finc_valor_base: parseMoedaParaNumero(formContrato.finc_valor_base),
                finc_cod_emp: Number(formContrato.finc_cod_emp) || 0,
                finc_dia_vencimento: Number(formContrato.finc_dia_vencimento) || 10,
                finc_tipo_abrangencia: tipoAbrangencia,
                usuario_logado: usuarioLogado,
                base64_contrato: base64Contrato,
                nome_contrato: nomeContrato,
                alcadas: alcadas.filter(a => a.matricula.trim() !== "")
            };

            await api.post('/financeiro/contrato', payload);
            toast.success(isEdicaoContrato ? "Contrato atualizado!" : "Novo contrato cadastrado!");
            setShowModalNovoContrato(false);
            carregarContratos();
        } catch (err) {
            console.error("Erro no salvamento do contrato:", err.response?.data || err);
            const mensagemDetalhada = err.response?.data?.erro || err.response?.data?.message || err.message;
            toast.error("Erro ao salvar contrato: " + mensagemDetalhada);
        } finally {
            setLoading(false);
        }
    };

    const handleAbrirModalNovoAnexo = (fincId) => {
        setFormAnexo({
            finc_id: fincId,
            fina_tipo: "ADENDO",
            fina_descricao: "",
            arq_anexo: null
        });
        setShowModalNovoAnexo(true);
    };

    const handleSalvarAnexo = async (e) => {
        e.preventDefault();
        if (!formAnexo.arq_anexo) {
            toast.warning("Selecione o arquivo PDF para anexar.");
            return;
        }

        setLoading(true);
        try {
            const base64Arq = await convertFileToBase64(formAnexo.arq_anexo);
            const payload = {
                finc_id: formAnexo.finc_id,
                fina_tipo: formAnexo.fina_tipo,
                fina_descricao: formAnexo.fina_descricao,
                nome_arquivo: formAnexo.arq_anexo.name,
                base64_arquivo: base64Arq,
                usuario_logado: usuarioLogado
            };

            await api.post('/financeiro/contrato/anexo', payload);
            toast.success("Adendo / Anexo cadastrado com sucesso!");
            setShowModalNovoAnexo(false);
            carregarContratos();
        } catch (err) {
            toast.error("Erro ao anexar documento ao contrato.");
        } finally {
            setLoading(false);
        }
    };

    const handleVerLogs = async (fincId) => {
        if (!fincId) {
            toast.warning("Identificador do contrato inválido.");
            return;
        }

        setLoading(true);
        try {
            const res = await api.get(`/financeiro/contrato/logs/${fincId}`);
            const listaRaw = Array.isArray(res.data) ? res.data : [];
            setLogsContrato(listaRaw.map(item => normalizarObjeto(item)));
            setShowModalLogs(true);
        } catch (err) {
            toast.error("Erro ao carregar logs do contrato.");
            setLogsContrato([]);
        } finally {
            setLoading(false);
        }
    };

    const handleAbrirLancarCompetencia = async (contrato) => {
        const itemNorm = normalizarObjeto(contrato);
        setContratoSelecionado(itemNorm);
        setLoading(true);
        let valorAnt = itemNorm.FINC_VALOR_BASE || 0;

        try {
            const res = await api.get(`/financeiro/contrato/${itemNorm.FINC_ID}/ultimovalor`);
            if (res.data && res.data.ultimo_valor > 0) {
                valorAnt = res.data.ultimo_valor;
            }
        } catch (err) {
        } finally {
            setLoading(false);
        }

        const d = new Date();
        const compAtual = `${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;

        setFormLancamento({
            finl_competencia: compAtual,
            finl_valor_total: formatarMoedaBR(valorAnt),
            finl_valor_anterior: valorAnt,
            finl_observacao: "",
            notas: [{
                finn_cod_emp: itemNorm.FINC_COD_EMP || 1,
                finn_tipo_nota: "SERVICO",
                finn_numero: "",
                finn_serie: "1",
                finn_data_emissao: "",
                finn_data_vencimento: "",
                finn_valor: formatarMoedaBR(valorAnt),
                arq_nota: null
            }]
        });

        setShowModalLancarCompetencia(true);
    };

    const handleAdicionarNotaLinha = () => {
        setFormLancamento({
            ...formLancamento,
            notas: [
                ...formLancamento.notas,
                {
                    finn_cod_emp: contratoSelecionado?.FINC_COD_EMP || 1,
                    finn_tipo_nota: "SERVICO",
                    finn_numero: "",
                    finn_serie: "1",
                    finn_data_emissao: "",
                    finn_data_vencimento: "",
                    finn_valor: "R$ 0,00",
                    arq_nota: null
                }
            ]
        });
    };

    const handleRemoverNotaLinha = (index) => {
        if (formLancamento.notas.length === 1) {
            toast.warning("A competência deve conter ao menos 1 nota fiscal.");
            return;
        }
        const novasNotas = formLancamento.notas.filter((_, i) => i !== index);
        recalcularValorTotal(novasNotas);
    };

    const handleUpdateNotaLinha = (index, field, value) => {
        const novasNotas = [...formLancamento.notas];
        novasNotas[index][field] = value;

        if (field === "finn_valor") {
            recalcularValorTotal(novasNotas);
        } else {
            setFormLancamento({ ...formLancamento, notas: novasNotas });
        }
    };

    const recalcularValorTotal = (listaNotas) => {
        const totalNum = listaNotas.reduce((sum, item) => sum + parseMoedaParaNumero(item.finn_valor), 0);
        setFormLancamento({
            ...formLancamento,
            notas: listaNotas,
            finl_valor_total: formatarMoedaBR(totalNum)
        });
    };

    const handleSalvarLancamentoCompetencia = async (e) => {
        e.preventDefault();

        const totalCalculado = parseMoedaParaNumero(formLancamento.finl_valor_total);
        const valorAnt = formLancamento.finl_valor_anterior;

        if (valorAnt > 0 && totalCalculado !== valorAnt && !formLancamento.finl_observacao.trim()) {
            toast.warning("O valor total é diferente do mês anterior! Preencha a justificativa.");
            return;
        }

        setLoading(true);
        try {
            const notasProcessadas = await Promise.all(
                formLancamento.notas.map(async (n) => {
                    let base64N = "";
                    let nomeN = "";
                    if (n.arq_nota) {
                        base64N = await convertFileToBase64(n.arq_nota);
                        nomeN = n.arq_nota.name;
                    }
                    return {
                        finn_cod_emp: Number(n.finn_cod_emp) || 1,
                        finn_tipo_nota: n.finn_tipo_nota,
                        finn_numero: n.finn_numero,
                        finn_serie: n.finn_serie,
                        finn_data_emissao: n.finn_data_emissao,
                        finn_data_vencimento: n.finn_data_vencimento,
                        finn_valor: parseMoedaParaNumero(n.finn_valor),
                        base64_nota: base64N,
                        nome_nota: nomeN
                    };
                })
            );

            const payload = {
                finc_id: contratoSelecionado.FINC_ID,
                finl_competencia: formLancamento.finl_competencia,
                finl_valor_total: totalCalculado,
                finl_valor_anterior: valorAnt,
                finl_observacao: formLancamento.finl_observacao,
                usuario_logado: usuarioLogado,
                notas: notasProcessadas
            };

            await api.post('/financeiro/lancamento', payload);
            toast.success("Lançamento da competência enviado para aprovação!");
            setShowModalLancarCompetencia(false);
            carregarContratos();
            carregarPendencias();
        } catch (err) {
            toast.error("Erro ao enviar lançamento da competência.");
        } finally {
            setLoading(false);
        }
    };

    const handleAprovarRejeitar = async (statusAprov) => {
        const itemNorm = normalizarObjeto(lancamentoPendSelecionado);

        if (statusAprov === 'SOLICITAR_OUTRA' && !chapaOutroAutorizador.trim()) {
            toast.warning("Informe a chapa do outro autorizador para transferir a assinatura.");
            return;
        }

        const confirm = await MySwal.fire({
            title: statusAprov === 'APROVADO' ? 'Confirmar Assinatura?' : statusAprov === 'SOLICITAR_OUTRA' ? 'Encaminhar Assinatura?' : 'Rejeitar Lançamento?',
            text: `Deseja registrar o status [${statusAprov}] para a competência ${itemNorm?.FINL_COMPETENCIA}?`,
            icon: statusAprov === 'APROVADO' ? 'question' : 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sim, Confirmar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: statusAprov === 'APROVADO' ? '#8b0000' : '#dc3545'
        });

        if (confirm.isConfirmed) {
            setLoading(true);
            try {
                await api.post('/financeiro/lancamento/aprovar', {
                    finl_id: itemNorm.FINL_ID,
                    fina_id: itemNorm.FINA_ID,
                    usuario_logado: usuarioLogado,
                    status_aprovação: statusAprov === 'REJEITADO' ? 'NEGADO' : statusAprov,
                    observacao: obsAprovacao,
                    redirecionar_matricula: chapaOutroAutorizador
                });

                if (statusAprov === 'REJEITADO' || statusAprov === 'NEGADO') {
                    toast.warn("Processo marcado como NEGADO. Devolvido ao criador para ajustes.");
                } else {
                    toast.success(`Assinatura registrada com sucesso!`);
                }

                setShowModalAprovar(false);
                carregarPendencias();
                carregarContratos();
                if (abaAtiva === "CENTRAL") {
                    carregarTodosLancamentos();
                }
            } catch (err) {
                toast.error("Erro ao registrar aprovação.");
            } finally {
                setLoading(false);
            }
        }
    };

    const handleAbrirAprovação = async (lancamento) => {
        const itemNorm = normalizarObjeto(lancamento);
        setLancamentoPendSelecionado(itemNorm);
        setObsAprovacao("");
        setChapaOutroAutorizador("");
        const finlId = itemNorm.FINL_ID;
        const fincId = itemNorm.FINC_ID;

        setLoading(true);
        try {
            await Promise.all([
                carregarNotasDoLancamento(finlId),
                carregarHistorico12Meses(fincId),
                carregarWorkflowAprovacoes(finlId),
                carregarAnexosDoContrato(fincId)
            ]);
            setShowModalAprovar(true);
        } catch (err) {
            toast.error("Erro ao carregar detalhes do lançamento.");
        } finally {
            setLoading(false);
        }
    };

    const handleVisualizarPDFNota = async (finnId, titulo) => {
        setLoading(true);
        try {
            const response = await api.get(`/financeiro/nota/download/${finnId}`, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const pdfUrl = URL.createObjectURL(blob);
            setTituloPdfView(titulo);
            setUrlPdfView(pdfUrl);
            setShowModalPDF(true);
        } catch (err) {
            toast.error("Erro ao carregar o PDF da Nota Fiscal.");
        } finally {
            setLoading(false);
        }
    };

    const handleVisualizarPDFContrato = async (fincId, titulo) => {
        setLoading(true);
        try {
            const response = await api.get(`/financeiro/contrato/download/${fincId}`, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const pdfUrl = URL.createObjectURL(blob);
            setTituloPdfView(titulo);
            setUrlPdfView(pdfUrl);
            setShowModalPDF(true);
        } catch (err) {
            toast.error("Erro ao carregar o PDF do Contrato.");
        } finally {
            setLoading(false);
        }
    };

    const handleVisualizarPDFAnexo = async (finaId, titulo) => {
        setLoading(true);
        try {
            const response = await api.get(`/financeiro/contrato/anexo/download/${finaId}`, { responseType: 'blob' });
            const blob = new Blob([response.data], { type: 'application/pdf' });
            const pdfUrl = URL.createObjectURL(blob);
            setTituloPdfView(titulo);
            setUrlPdfView(pdfUrl);
            setShowModalPDF(true);
        } catch (err) {
            toast.error("Erro ao carregar o PDF do Anexo.");
        } finally {
            setLoading(false);
        }
    };

    const lancamentosFiltradosCentral = todosLancamentos.filter(item => {
        const st = String(item.STATUS_GERAL || item.FINL_STATUS || 'PENDENTE').trim().toUpperCase();
        if (filtroStatusCentral === "TODOS") return true;
        if (filtroStatusCentral === "NEGADO") return st === "NEGADO" || st === "REJEITADO";
        return st === filtroStatusCentral;
    });

    const todasAlcadasAprovadas = aprovacoesWorkflow.length > 0 &&
        aprovacoesWorkflow.every(wf => String(wf.FINP_STATUS || '').trim().toUpperCase() === 'APROVADO');

    const statusGeralRegistro = String(lancamentoPendSelecionado?.STATUS_GERAL || lancamentoPendSelecionado?.FINL_STATUS || 'PENDENTE').trim().toUpperCase();

    const isLancamentoPendente = statusGeralRegistro === 'PENDENTE' && !todasAlcadasAprovadas;

    return (
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
            <Menu modulo="ARBOR" />

            <Container fluid className="px-3 px-md-4 pt-5 mt-4 mb-5" style={{ flex: 1 }}>

                {/* Cabeçalho da Página e Navegação por Abas */}
                <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-4 bg-white p-3 rounded-3 shadow-sm border">
                    <div className="d-flex align-items-center gap-2">
                        <FaFileInvoice style={{ color: '#8b0000' }} className="fs-3" />
                        <div>
                            <h5 className="fw-bold text-dark mb-0">Ficha Financeira & Contratos</h5>
                            <small className="text-muted">Gestão estratégica de contratos, adendos e fluxo de aprovação de NFs</small>
                        </div>
                    </div>
                    <div className="d-flex align-items-center flex-wrap gap-2">
                        <Button
                            style={abaAtiva === "PENDENCIAS" ? { backgroundColor: '#8b0000', borderColor: '#8b0000', color: '#ffffff' } : { color: '#8b0000', borderColor: '#8b0000', backgroundColor: 'transparent' }}
                            className="fw-bold d-flex align-items-center gap-1 shadow-sm"
                            onClick={() => setAbaAtiva("PENDENCIAS")}
                        >
                            <FaClipboardList size={14} /> Minhas Pendências
                            <Badge bg="light" text="dark" className="ms-1">{pendencias.length}</Badge>
                        </Button>
                        <Button
                            style={abaAtiva === "CONTRATOS" ? { backgroundColor: '#8b0000', borderColor: '#8b0000', color: '#ffffff' } : { color: '#8b0000', borderColor: '#8b0000', backgroundColor: 'transparent' }}
                            className="fw-bold d-flex align-items-center gap-1 shadow-sm"
                            onClick={() => setAbaAtiva("CONTRATOS")}
                        >
                            <FaFolderOpen size={14} /> Todos os Contratos
                        </Button>
                        <Button
                            style={abaAtiva === "CENTRAL" ? { backgroundColor: '#8b0000', borderColor: '#8b0000', color: '#ffffff' } : { color: '#8b0000', borderColor: '#8b0000', backgroundColor: 'transparent' }}
                            className="fw-bold d-flex align-items-center gap-1 shadow-sm"
                            onClick={() => {
                                setAbaAtiva("CENTRAL");
                                carregarTodosLancamentos();
                            }}
                        >
                            <FaChartBar size={14} /> Central de Acompanhamento
                        </Button>
                        <Button
                            style={{ backgroundColor: '#8b0000', borderColor: '#8b0000', color: '#ffffff' }}
                            className="fw-bold d-flex align-items-center gap-1 shadow-sm px-3"
                            onClick={handleNovoContratoModal}
                        >
                            <FaPlus size={12} /> Novo Contrato
                        </Button>
                    </div>
                </div>

                {abaAtiva === "PENDENCIAS" && (
                    <Card className="shadow-sm border-0 rounded-3 bg-white overflow-hidden">
                        <Card.Header className="bg-white fw-bold text-dark py-3 px-3 d-flex justify-content-between align-items-center border-bottom">
                            <span className="text-secondary small">PENDÊNCIAS DE ASSINATURA | USUÁRIO: <strong className="text-dark">[{usuarioLogado}]</strong></span>
                            <Badge bg="warning" text="dark" className="px-2 py-1 rounded-2">{pendencias.length} Aguardando</Badge>
                        </Card.Header>
                        <Card.Body className="p-0">
                            <Table responsive hover className="align-middle mb-0">
                                <thead className="table-light small">
                                    <tr>
                                        <th className="py-2 px-3">Departamento / Contrato</th>
                                        <th className="py-2">Fornecedor</th>
                                        <th className="py-2">Competência</th>
                                        <th className="py-2">Qtd. Notas</th>
                                        <th className="py-2">Valor Total Mês</th>
                                        <th className="py-2">Sua Alçada</th>
                                        <th className="py-2 text-end px-3">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {pendencias.length === 0 ? (
                                        <tr>
                                            <td colSpan="7" className="text-center py-5 text-muted">
                                                Nenhum lançamento pendente de sua assinatura no momento.
                                            </td>
                                        </tr>
                                    ) : (
                                        pendencias.map((l, i) => (
                                            <tr key={i}>
                                                <td className="px-3">
                                                    <Badge style={{ backgroundColor: '#8b0000' }} className="me-2">{l.FINC_DEPARTAMENTO || 'TI'}</Badge>
                                                    <strong className="text-dark">{l.FINC_DESCRICAO}</strong>
                                                </td>
                                                <td className="text-secondary">{l.FINC_FORNECEDOR}</td>
                                                <td className="fw-bold text-danger">{l.FINL_COMPETENCIA}</td>
                                                <td><Badge bg="secondary-subtle" text="secondary" className="border border-secondary-subtle">{l.QTD_NOTAS || 1} NF(s)</Badge></td>
                                                <td className="fw-bold text-danger fs-6">
                                                    {formatarMoedaBR(l.FINL_VALOR_TOTAL)}
                                                </td>
                                                <td><Badge bg="warning-subtle" text="warning-emphasis" className="border border-warning-subtle fw-bold">{l.FINA_CARGO}</Badge></td>
                                                <td className="text-end px-3">
                                                    <Button
                                                        size="sm"
                                                        style={{ backgroundColor: '#8b0000', borderColor: '#8b0000', color: '#ffffff' }}
                                                        className="fw-bold shadow-sm py-1 px-3"
                                                        onClick={() => handleAbrirAprovação(l)}
                                                    >
                                                        🖋️ Analisar & Assinar
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>
                )}

                {abaAtiva === "CONTRATOS" && (
                    <>
                        <Card className="shadow-sm border-0 mb-3 p-3 bg-white rounded-3">
                            <Row className="g-2 align-items-center">
                                <Col md={4}>
                                    <Form.Select
                                        size="sm"
                                        value={filtroDepto}
                                        onChange={(e) => setFiltroDepto(e.target.value)}
                                    >
                                        <option value="">Todos os Departamentos</option>
                                        {LISTA_DEPARTAMENTOS.map(d => (
                                            <option key={d} value={d}>{d}</option>
                                        ))}
                                    </Form.Select>
                                </Col>
                                <Col md={4}>
                                    <InputGroup size="sm">
                                        <Form.Control
                                            placeholder="Buscar por Descrição ou Razão Social..."
                                            value={filtroBusca}
                                            onChange={(e) => setFiltroBusca(e.target.value)}
                                            onKeyDown={(e) => e.key === 'Enter' && carregarContratos()}
                                        />
                                        <Button style={{ backgroundColor: '#8b0000', borderColor: '#8b0000', color: '#ffffff' }} className="fw-bold" onClick={carregarContratos}>Buscar</Button>
                                    </InputGroup>
                                </Col>

                                <Col md={4} className="d-flex justify-content-end align-items-center gap-2">
                                    <OverlayTrigger
                                        trigger="click"
                                        rootClose
                                        placement="bottom-end"
                                        overlay={
                                            <Popover id="popover-dias-vencimento" style={{ maxWidth: '340px' }}>
                                                <Popover.Header as="h3" className="d-flex justify-content-between align-items-center py-2 bg-light">
                                                    <span className="fw-bold small text-dark">Filtrar Dia do Vencimento:</span>
                                                    {diasSelecionados.length > 0 && (
                                                        <Button
                                                            size="sm"
                                                            variant="link"
                                                            className="p-0 text-danger small text-decoration-none fw-bold"
                                                            onClick={() => setDiasSelecionados([])}
                                                        >
                                                            Limpar
                                                        </Button>
                                                    )}
                                                </Popover.Header>
                                                <Popover.Body className="p-2">
                                                    <div className="d-flex flex-wrap gap-1 mb-2">
                                                        {Array.from({ length: 31 }, (_, idx) => idx + 1).map((dia) => {
                                                            const isSel = diasSelecionados.includes(dia);
                                                            return (
                                                                <Button
                                                                    key={dia}
                                                                    size="sm"
                                                                    style={isSel ? { backgroundColor: '#8b0000', borderColor: '#8b0000', width: '35px', height: '35px', fontSize: '0.82rem' } : { width: '35px', height: '35px', fontSize: '0.82rem' }}
                                                                    variant={isSel ? "primary" : "outline-secondary"}
                                                                    className="fw-bold p-0 d-flex align-items-center justify-content-center"
                                                                    onClick={() => toggleDiaFiltro(dia)}
                                                                >
                                                                    {String(dia).padStart(2, '0')}
                                                                </Button>
                                                            );
                                                        })}
                                                    </div>
                                                    <div className="pt-2 border-top text-end">
                                                        <Button
                                                            size="sm"
                                                            style={{ backgroundColor: '#8b0000', borderColor: '#8b0000', color: '#ffffff' }}
                                                            className="fw-bold w-100"
                                                            onClick={() => {
                                                                carregarContratos();
                                                                document.body.click();
                                                            }}
                                                        >
                                                            Aplicar Filtro
                                                        </Button>
                                                    </div>
                                                </Popover.Body>
                                            </Popover>
                                        }
                                    >
                                        <Button variant={diasSelecionados.length > 0 ? "warning" : "outline-secondary"} size="sm" className="fw-bold d-flex align-items-center gap-1">
                                            <FaCalendarAlt size={12} /> Dia Vencimento {diasSelecionados.length > 0 ? `(${diasSelecionados.length})` : ""}
                                        </Button>
                                    </OverlayTrigger>
                                </Col>
                            </Row>
                        </Card>

                        <Card className="shadow-sm border-0 rounded-3 bg-white overflow-hidden">
                            <Card.Body className="p-0">
                                <Table responsive hover className="align-middle mb-0">
                                    <thead className="table-light small">
                                        <tr>
                                            <th className="py-2 px-3">Departamento</th>
                                            <th className="py-2">Contrato / Fornecedor</th>
                                            <th className="py-2">Vigência (Início / Fim)</th>
                                            <th className="py-2">Abrangência / Loja</th>
                                            <th className="py-2">Índice & Venc.</th>
                                            <th className="py-2 text-center">Status Lembrete</th>
                                            <th className="py-2">Anexos</th>
                                            <th className="py-2">Valor Base</th>
                                            <th className="py-2 text-end px-3">Ações</th>
                                        </tr>
                                    </thead>
                                    <tbody className="small">
                                        {contratos.length === 0 ? (
                                            <tr>
                                                <td colSpan="9" className="text-center py-5 text-muted">
                                                    Nenhum contrato encontrado para os filtros aplicados.
                                                </td>
                                            </tr>
                                        ) : (
                                            contratos.map((c, i) => {
                                                const idContrato = c.FINC_ID;
                                                const qtdAnexos = c.QTD_ANEXOS || 0;
                                                const diaVenc = c.FINC_DIA_VENCIMENTO || 10;

                                                return (
                                                    <tr key={i}>
                                                        <td className="px-3">
                                                            <Badge style={{ backgroundColor: '#8b0000' }}>{c.FINC_DEPARTAMENTO || 'TI'}</Badge>
                                                        </td>
                                                        <td>
                                                            <strong className="text-danger">{c.FINC_DESCRICAO}</strong><br />
                                                            <small className="text-muted">{c.FINC_FORNECEDOR}</small>
                                                        </td>
                                                        <td>
                                                            <small className="d-block text-dark fw-semibold">
                                                                📅 {c.FINC_DATA_INICIO || '01/01/2026'} até {c.FINC_DATA_FIM || '31/12/2026'}
                                                            </small>
                                                        </td>
                                                        <td>
                                                            {c.FINC_TIPO_ABRANGENCIA === 'GLOBAL' ?
                                                                <Badge bg="info-subtle" text="info-emphasis" className="border border-info-subtle">GLOBAL (Todas Filiais)</Badge> :
                                                                <Badge bg="secondary-subtle" text="secondary" className="border border-secondary-subtle">Filial {c.FINC_COD_EMP}</Badge>}
                                                        </td>
                                                        <td>
                                                            <strong>{c.FINC_INDICE_REAJUSTE}</strong><br />
                                                            <Badge bg="dark" className="mt-1">Dia {diaVenc}</Badge>
                                                        </td>
                                                        <td className="text-center align-middle">
                                                            {renderStatusLembrete(c)}
                                                        </td>
                                                        <td>
                                                            <Badge bg="light" text="dark" className="border p-2 rounded-2">📎 {qtdAnexos} Anexo(s)</Badge>
                                                        </td>
                                                        <td className="fw-bold text-dark">{formatarMoedaBR(c.FINC_VALOR_BASE)}</td>
                                                        <td className="text-end px-3">
                                                            <div className="d-flex justify-content-end gap-1">
                                                                <Button
                                                                    size="sm"
                                                                    variant="outline-danger"
                                                                    className="fw-bold py-0 px-2"
                                                                    title="Ver Histórico de Lançamentos e Assinaturas"
                                                                    onClick={(e) => handleAbrirHistoricoCompleto(idContrato, e)}
                                                                >
                                                                    📊
                                                                </Button>
                                                                <Button
                                                                    size="sm"
                                                                    variant="outline-warning"
                                                                    className="fw-bold py-0 px-2"
                                                                    title="Anexar Adendo ou Reajuste"
                                                                    onClick={() => handleAbrirModalNovoAnexo(idContrato)}
                                                                >
                                                                    📎
                                                                </Button>
                                                                <Button
                                                                    size="sm"
                                                                    variant="outline-secondary"
                                                                    className="py-0 px-2"
                                                                    title="Logs de Edição"
                                                                    onClick={() => handleVerLogs(idContrato)}
                                                                >
                                                                    📜
                                                                </Button>
                                                                <Button
                                                                    size="sm"
                                                                    variant="outline-danger"
                                                                    className="py-0 px-2"
                                                                    title="Ver / Editar Contrato Completo"
                                                                    onClick={() => handleAbrirEditarContrato(idContrato)}
                                                                >
                                                                    ✏️
                                                                </Button>
                                                                <Button
                                                                    size="sm"
                                                                    style={{ backgroundColor: '#8b0000', borderColor: '#8b0000', color: '#ffffff' }}
                                                                    className="fw-bold py-0 px-2"
                                                                    title="Lançar Competência (NFs)"
                                                                    onClick={() => handleAbrirLancarCompetencia(c)}
                                                                >
                                                                    ➕ Competência
                                                                </Button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        )}
                                    </tbody>
                                </Table>
                            </Card.Body>
                        </Card>
                    </>
                )}

                {abaAtiva === "CENTRAL" && (
                    <Card className="shadow-sm border-0 rounded-3 bg-white overflow-hidden" style={{ backgroundColor: '#ffffff' }}>
                        <Card.Header className="bg-white p-3 border-bottom d-flex justify-content-between align-items-center flex-wrap gap-2" style={{ backgroundColor: '#ffffff', color: '#212529' }}>
                            <div>
                                <span className="fw-bold text-dark d-block fs-6">Visão Geral dos Lançamentos</span>
                                <small className="text-muted">Acompanhamento e rastreio de alçadas ativas e aprovadas</small>
                            </div>
                            <div>
                                <ButtonGroup size="sm">
                                    <Button
                                        style={filtroStatusCentral === "TODOS" ? { backgroundColor: '#8b0000', borderColor: '#8b0000', color: '#ffffff' } : { color: '#8b0000', borderColor: '#8b0000', backgroundColor: '#ffffff' }}
                                        className="fw-bold"
                                        onClick={() => setFiltroStatusCentral("TODOS")}
                                    >
                                        Todos ({todosLancamentos.length})
                                    </Button>
                                    <Button
                                        style={filtroStatusCentral === "PENDENTE" ? { backgroundColor: '#ffc107', borderColor: '#ffc107', color: '#000000' } : { color: '#856404', borderColor: '#ffeeba', backgroundColor: '#fff3cd' }}
                                        className="fw-bold"
                                        onClick={() => setFiltroStatusCentral("PENDENTE")}
                                    >
                                        ⏳ Pendentes ({todosLancamentos.filter(x => String(x.STATUS_GERAL || x.FINL_STATUS || 'PENDENTE').trim().toUpperCase() === 'PENDENTE').length})
                                    </Button>
                                    <Button
                                        style={filtroStatusCentral === "APROVADO" ? { backgroundColor: '#198754', borderColor: '#198754', color: '#ffffff' } : { color: '#155724', borderColor: '#c3e6cb', backgroundColor: '#d4edda' }}
                                        className="fw-bold"
                                        onClick={() => setFiltroStatusCentral("APROVADO")}
                                    >
                                        ✓ Aprovados ({todosLancamentos.filter(x => String(x.STATUS_GERAL || x.FINL_STATUS || '').trim().toUpperCase() === 'APROVADO').length})
                                    </Button>
                                    <Button
                                        style={filtroStatusCentral === "NEGADO" ? { backgroundColor: '#dc3545', borderColor: '#dc3545', color: '#ffffff' } : { color: '#721c24', borderColor: '#f5c6cb', backgroundColor: '#f8d7da' }}
                                        className="fw-bold"
                                        onClick={() => setFiltroStatusCentral("NEGADO")}
                                    >
                                        ❌ Negados ({todosLancamentos.filter(x => {
                                            const st = String(x.STATUS_GERAL || x.FINL_STATUS || '').trim().toUpperCase();
                                            return st === 'NEGADO' || st === 'REJEITADO';
                                        }).length})
                                    </Button>
                                </ButtonGroup>
                            </div>
                        </Card.Header>
                        <Card.Body className="p-0 bg-white">
                            <Table responsive hover className="align-middle mb-0">
                                <thead className="table-light small">
                                    <tr>
                                        <th className="py-2 px-3">Departamento</th>
                                        <th className="py-2">Contrato / Fornecedor</th>
                                        <th className="py-2">Competência</th>
                                        <th className="py-2">Valor Total</th>
                                        <th className="py-2">Status Atual</th>
                                        <th className="py-2">Usuário Lançamento / Aprovador Atual</th>
                                        <th className="py-2 text-center px-3">Ações</th>
                                    </tr>
                                </thead>
                                <tbody className="small">
                                    {lancamentosFiltradosCentral.length === 0 ? (
                                        <tr>
                                            <td colSpan="7" className="text-center py-5 text-muted">
                                                Nenhum lançamento encontrado para o filtro selecionado.
                                            </td>
                                        </tr>
                                    ) : (
                                        lancamentosFiltradosCentral.map((item, i) => {
                                            const statusGeral = String(item.STATUS_GERAL || item.FINL_STATUS || 'PENDENTE').trim().toUpperCase();
                                            const isAprov = statusGeral === 'APROVADO';
                                            const isNegado = statusGeral === 'NEGADO' || statusGeral === 'REJEITADO';

                                            return (
                                                <tr key={i}>
                                                    <td className="px-3">
                                                        <Badge style={{ backgroundColor: '#8b0000' }}>{item.FINC_DEPARTAMENTO || 'TI'}</Badge>
                                                    </td>
                                                    <td>
                                                        <strong className="text-dark">{item.FINC_DESCRICAO}</strong><br />
                                                        <small className="text-muted">{item.FINC_FORNECEDOR}</small>
                                                    </td>
                                                    <td className="fw-bold text-danger">{item.FINL_COMPETENCIA}</td>
                                                    <td className="fw-bold text-danger">
                                                        {formatarMoedaBR(item.FINL_VALOR_TOTAL)}
                                                    </td>
                                                    <td>
                                                        <Badge bg={isAprov ? 'success' : isNegado ? 'danger' : 'warning'} className="rounded-2">
                                                            {isNegado ? 'NEGADO' : statusGeral}
                                                        </Badge>
                                                    </td>
                                                    <td>
                                                        <small className="text-muted d-block">
                                                            <strong>Lançado por:</strong> {item.NOME_LANCADOR ? `${item.NOME_LANCADOR} [${item.USUARIO_LANCAMENTO}]` : `Chapa: ${item.USUARIO_LANCAMENTO || '-'}`} ({item.DATA_LANCAMENTO || '-'})
                                                        </small>
                                                        {isAprov ? (
                                                            <span className="text-success small fw-bold d-inline-flex align-items-center gap-1"><FaCheck size={10} /> Totalmente Aprovado</span>
                                                        ) : isNegado ? (
                                                            <span className="text-danger small fw-bold d-inline-flex align-items-center gap-1"><FaTimes size={10} /> Processo Negado (Devolvido para ajustes)</span>
                                                        ) : (
                                                            <div className="mt-1">
                                                                <strong className="text-dark small d-block">
                                                                    ⏳ Aguardando: {item.NOME_APROVADOR_ATUAL ? `${item.NOME_APROVADOR_ATUAL} [${item.CHAPA_APROVADOR_ATUAL}]` : (item.CHAPA_APROVADOR_ATUAL ? `Chapa: ${item.CHAPA_APROVADOR_ATUAL}` : 'Alçada')}
                                                                </strong>
                                                                <small className="text-muted">
                                                                    ({item.CARGO_APROVADOR_ATUAL || 'Alçada Ativa'})
                                                                </small>
                                                            </div>
                                                        )}
                                                    </td>
                                                    <td className="text-center px-3">
                                                        <Button
                                                            size="sm"
                                                            variant="outline-danger"
                                                            className="fw-semibold py-1 px-2"
                                                            onClick={() => handleAbrirAprovação(item)}
                                                        >
                                                            🔍 Detalhes
                                                        </Button>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    )}
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>
                )}
            </Container>

            {/* MODAL DETALHAMENTO DE HISTÓRICO E ASSINATURAS DO CONTRATO */}
            <Modal show={showModalHistoricoCompleto} onHide={() => setShowModalHistoricoCompleto(false)} size="xl" centered scrollable>
                <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #8b0000 0%, #a91b0d 50%, #c0392b 100%)', color: '#ffffff' }} className="py-2 px-3 border-0">
                    <Modal.Title className="fs-6 fw-bold text-white">
                        Ficha Financeira - Competência: {lancamentoAtivoVisao?.FINL_COMPETENCIA || '-'} [{lancamentoAtivoVisao?.FINC_DEPARTAMENTO || 'DEPARTAMENTO'}]
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-3 bg-light">
                    {!lancamentoAtivoVisao ? (
                        <div className="text-center py-5 text-muted bg-white rounded-3 shadow-sm">
                            <h5>Nenhum lançamento gravado para este contrato ainda.</h5>
                            <p className="small">Utilize o botão "+ Lançar Competência (NFs)" no menu de contratos para incluir a primeira ficha.</p>
                        </div>
                    ) : (
                        <>
                            <Card className="mb-3 border-0 bg-white shadow-sm rounded-3 overflow-hidden">
                                <Card.Header className="bg-white fw-bold small py-2 px-3 text-danger border-bottom">
                                    <span>👥 Fluxo de Assinaturas e Histórico das Alçadas</span>
                                </Card.Header>
                                <Card.Body className="p-0">
                                    <Table responsive size="sm" className="mb-0 align-middle">
                                        <thead className="table-light small">
                                            <tr>
                                                <th className="px-3">Ordem</th>
                                                <th>Cargo / Alçada</th>
                                                <th>Aprovador</th>
                                                <th>Status Assinatura</th>
                                                <th>Data/Hora</th>
                                                <th className="px-3">Observação</th>
                                            </tr>
                                        </thead>
                                        <tbody className="small">
                                            {aprovacoesWorkflow.map((wf, widx) => {
                                                const status = String(wf.FINP_STATUS || 'PENDENTE').trim().toUpperCase();
                                                const isAprov = status === 'APROVADO';
                                                const isRej = status === 'REJEITADO' || status === 'NEGADO';
                                                const matricula = wf.MATRICULA_CORRETA || wf.FINA_MATRICULA || '';
                                                const dataHora = wf.FINP_DATAHORA || '-';
                                                const obs = wf.FINP_OBSERVACAO || '-';

                                                return (
                                                    <tr key={widx}>
                                                        <td className="fw-bold px-3">#{wf.FINA_ORDEM || widx + 1}</td>
                                                        <td><Badge bg="secondary-subtle" text="secondary" className="border border-secondary-subtle">{wf.FINA_CARGO}</Badge></td>
                                                        <td>
                                                            <strong>
                                                                {wf.NOME_COLABORADOR
                                                                    ? `${wf.NOME_COLABORADOR} [${matricula}]`
                                                                    : (matricula ? `Chapa: ${matricula}` : 'Aprovador não definido')}
                                                            </strong>
                                                        </td>
                                                        <td>
                                                            <Badge bg={isAprov ? 'success' : isRej ? 'danger' : 'warning'}>
                                                                {isAprov ? '✓ Aprovado' : isRej ? '❌ Negado' : '⏳ Aguardando'}
                                                            </Badge>
                                                        </td>
                                                        <td className="text-secondary">{dataHora}</td>
                                                        <td className="px-3 text-secondary">{obs}</td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </Table>
                                </Card.Body>
                            </Card>

                            <Row className="g-3 mb-3">
                                <Col md={7}>
                                    <Card className="h-100 border-0 shadow-sm rounded-3 p-3 bg-white">
                                        <h6 className="fw-bold text-danger mb-3">Resumo da Competência Atual</h6>

                                        <div className="p-2 mb-3 bg-light rounded-3 border">
                                            <small className="fw-bold text-secondary d-block mb-1">📄 Documentos e Adendos do Contrato:</small>
                                            <div className="d-flex flex-wrap gap-1 align-items-center">
                                                {anexosContratoSelecionado && anexosContratoSelecionado.length > 0 ? (
                                                    anexosContratoSelecionado.map((anx, idxAnx) => {
                                                        const idAnx = anx.FINA_ID;
                                                        const tipoAnx = anx.FINA_TIPO || "DOCUMENTO";
                                                        const descAnx = anx.FINA_DESCRICAO || anx.FINA_NOME_ARQ || "PDF";

                                                        return (
                                                            <Button
                                                                key={idxAnx}
                                                                size="sm"
                                                                style={{ backgroundColor: '#8b0000', borderColor: '#8b0000', fontSize: '0.72rem', color: '#ffffff' }}
                                                                className="py-1 px-2 fw-bold shadow-sm"
                                                                onClick={() => handleVisualizarPDFAnexo(idAnx, `${tipoAnx}: ${descAnx}`)}
                                                            >
                                                                👁️ {tipoAnx}: {descAnx}
                                                            </Button>
                                                        );
                                                    })
                                                ) : (
                                                    <Button
                                                        size="sm"
                                                        style={{ backgroundColor: '#8b0000', borderColor: '#8b0000', fontSize: '0.75rem', color: '#ffffff' }}
                                                        className="py-1 px-2 fw-bold shadow-sm"
                                                        onClick={() => handleVisualizarPDFContrato(
                                                            lancamentoAtivoVisao?.FINC_ID,
                                                            'Contrato Principal PDF'
                                                        )}
                                                    >
                                                        👁️ Ver PDF do Contrato
                                                    </Button>
                                                )}
                                            </div>
                                        </div>

                                        <p className="mb-1 small"><strong>Departamento:</strong> <Badge style={{ backgroundColor: '#8b0000' }} className="ms-1">{lancamentoAtivoVisao?.FINC_DEPARTAMENTO || 'TI'}</Badge></p>
                                        <p className="mb-1 small"><strong>Contrato:</strong> {lancamentoAtivoVisao?.FINC_DESCRICAO}</p>
                                        <p className="mb-1 small"><strong>Fornecedor:</strong> {lancamentoAtivoVisao?.FINC_FORNECEDOR}</p>
                                        <p className="mb-2 small"><strong>Valor Total Consolidado:</strong> <span className="fs-5 fw-bold text-danger ms-1">{formatarMoedaBR(lancamentoAtivoVisao?.FINL_VALOR_TOTAL)}</span></p>

                                        {lancamentoAtivoVisao?.FINL_OBSERVACAO && (
                                            <div className="alert alert-warning p-2 small rounded-2 mb-3">
                                                <strong>Justificativa de Alteração / Dólar / Reajuste:</strong><br />
                                                {lancamentoAtivoVisao?.FINL_OBSERVACAO}
                                            </div>
                                        )}

                                        <h6 className="fw-bold text-dark mt-2 mb-2">Notas Fiscais Vinculadas a este Lançamento</h6>
                                        <Table responsive striped bordered hover size="sm" className="small align-middle mb-0">
                                            <thead className="table-light">
                                                <tr>
                                                    <th>Tipo</th>
                                                    <th>Nº Nota</th>
                                                    <th>Loja</th>
                                                    <th>Vencimento</th>
                                                    <th>Valor</th>
                                                    <th className="text-center">PDF</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {notasDoLancamento.map((nf, idx) => (
                                                    <tr key={idx}>
                                                        <td><Badge bg="secondary">{nf.FINN_TIPO_NOTA}</Badge></td>
                                                        <td className="fw-bold">{nf.FINN_NUMERO}</td>
                                                        <td>Loja {nf.FINN_COD_EMP}</td>
                                                        <td>{nf.FINN_DATA_VENCIMENTO}</td>
                                                        <td>{formatarMoedaBR(nf.FINN_VALOR)}</td>
                                                        <td className="text-center">
                                                            <Button
                                                                size="sm"
                                                                variant="outline-danger"
                                                                className="py-0 px-2"
                                                                style={{ fontSize: '0.7rem' }}
                                                                onClick={() => handleVisualizarPDFNota(nf.FINN_ID, `Visualizar NF ${nf.FINN_NUMERO}`)}
                                                            >
                                                                👁️ Ver PDF
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </Table>
                                    </Card>
                                </Col>

                                <Col md={5}>
                                    <Card className="h-100 border-0 shadow-sm rounded-3 p-3 bg-white">
                                        <h6 className="fw-bold text-dark mb-3">Últimas 12 Competências</h6>
                                        <div style={{ maxHeight: '350px', overflowY: 'auto' }}>
                                            <Table striped bordered hover size="sm" className="small align-middle mb-0">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th>Mês/Ano</th>
                                                        <th>Total Mês</th>
                                                        <th>Qtd. NFs</th>
                                                        <th>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {listaLancamentosContrato.map((h, index) => {
                                                        const isSelecionado = h.FINL_ID === lancamentoAtivoVisao?.FINL_ID;
                                                        const stStr = String(h.STATUS_GERAL || h.FINL_STATUS || '').trim().toUpperCase();

                                                        return (
                                                            <tr
                                                                key={index}
                                                                onClick={() => handleTrocarCompetenciaVisao(h)}
                                                                style={{
                                                                    cursor: 'pointer',
                                                                    backgroundColor: isSelecionado ? '#f8d7da' : 'transparent',
                                                                    fontWeight: isSelecionado ? 'bold' : 'normal'
                                                                }}
                                                            >
                                                                <td className="text-danger">{h.FINL_COMPETENCIA}</td>
                                                                <td>{formatarMoedaBR(h.FINL_VALOR_TOTAL)}</td>
                                                                <td>{h.QTD_NOTAS || 1} NF(s)</td>
                                                                <td>
                                                                    <Badge bg={stStr === 'APROVADO' ? 'success' : stStr === 'NEGADO' ? 'danger' : 'warning'}>
                                                                        {stStr}
                                                                    </Badge>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })}
                                                </tbody>
                                            </Table>
                                        </div>
                                    </Card>
                                </Col>
                            </Row>
                        </>
                    )}
                </Modal.Body>
                <Modal.Footer className="bg-white border-top-0 py-2 px-3 d-flex justify-content-between align-items-center">
                    <Badge bg={String(lancamentoAtivoVisao?.STATUS_GERAL || lancamentoAtivoVisao?.FINL_STATUS || '').trim().toUpperCase() === 'APROVADO' ? 'success' : 'warning'} className="p-2 fs-6 rounded-2">
                        Status Final: {lancamentoAtivoVisao?.STATUS_GERAL || lancamentoAtivoVisao?.FINL_STATUS || 'PENDENTE'}
                    </Badge>
                    <Button variant="secondary" size="sm" className="fw-semibold" onClick={() => setShowModalHistoricoCompleto(false)}>Fechar</Button>
                </Modal.Footer>
            </Modal>

            {/* MODAL DE APROVAÇÃO / ASSINATURA */}
            <Modal show={showModalAprovar} onHide={() => setShowModalAprovar(false)} size="xl" centered scrollable>
                <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #8b0000 0%, #a91b0d 50%, #c0392b 100%)', color: '#ffffff' }} className="py-2 px-3 border-0">
                    <Modal.Title className="fs-6 fw-bold text-white">
                        Ficha Financeira - Competência: {lancamentoPendSelecionado?.FINL_COMPETENCIA} [{lancamentoPendSelecionado?.FINC_DEPARTAMENTO || 'DEPARTAMENTO'}]
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-3 bg-light">
                    <Card className="mb-3 border-0 bg-white shadow-sm rounded-3 overflow-hidden">
                        <Card.Header className="bg-white fw-bold small py-2 px-3 text-danger border-bottom">
                            👥 Fluxo de Assinaturas e Histórico das Alçadas
                        </Card.Header>
                        <Card.Body className="p-0">
                            <Table responsive size="sm" className="mb-0 align-middle">
                                <thead className="table-light small">
                                    <tr>
                                        <th className="px-3">Ordem</th>
                                        <th>Cargo / Alçada</th>
                                        <th>Aprovador</th>
                                        <th>Status Assinatura</th>
                                        <th>Data/Hora</th>
                                        <th className="px-3">Observação</th>
                                    </tr>
                                </thead>
                                <tbody className="small">
                                    {aprovacoesWorkflow.map((wf, widx) => {
                                        const status = String(wf.FINP_STATUS || 'PENDENTE').trim().toUpperCase();
                                        const isAprov = status === 'APROVADO';
                                        const isRej = status === 'REJEITADO' || status === 'NEGADO';
                                        const matricula = wf.MATRICULA_CORRETA || wf.FINA_MATRICULA || '';
                                        const dataHora = wf.FINP_DATAHORA || '-';
                                        const obs = wf.FINP_OBSERVACAO || '-';

                                        return (
                                            <tr key={widx}>
                                                <td className="fw-bold px-3">#{wf.FINA_ORDEM || widx + 1}</td>
                                                <td><Badge bg="secondary-subtle" text="secondary" className="border border-secondary-subtle">{wf.FINA_CARGO}</Badge></td>
                                                <td>
                                                    <strong>
                                                        {wf.NOME_COLABORADOR
                                                            ? `${wf.NOME_COLABORADOR} [${matricula}]`
                                                            : (matricula ? `Chapa: ${matricula}` : 'Aprovador não definido')}
                                                    </strong>
                                                </td>
                                                <td>
                                                    <Badge bg={isAprov ? 'success' : isRej ? 'danger' : 'warning'}>
                                                        {isAprov ? '✓ Aprovado' : isRej ? '❌ Negado' : '⏳ Aguardando'}
                                                    </Badge>
                                                </td>
                                                <td className="text-secondary">{dataHora}</td>
                                                <td className="px-3 text-secondary">{obs}</td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>

                    <Row className="g-3 mb-3">
                        <Col md={7}>
                            <Card className="h-100 border-0 shadow-sm rounded-3 p-3 bg-white">
                                <h6 className="fw-bold text-danger mb-3">Resumo da Competência Atual</h6>

                                <div className="p-2 mb-3 bg-light rounded-3 border">
                                    <small className="fw-bold text-secondary d-block mb-1">📄 Documentos e Adendos do Contrato:</small>
                                    <div className="d-flex flex-wrap gap-1 align-items-center">
                                        {anexosContratoSelecionado && anexosContratoSelecionado.length > 0 ? (
                                            anexosContratoSelecionado.map((anx, idxAnx) => {
                                                const idAnx = anx.FINA_ID;
                                                const tipoAnx = anx.FINA_TIPO || "DOCUMENTO";
                                                const descAnx = anx.FINA_DESCRICAO || anx.FINA_NOME_ARQ || "PDF";

                                                return (
                                                    <Button
                                                        key={idxAnx}
                                                        size="sm"
                                                        style={{ backgroundColor: '#8b0000', borderColor: '#8b0000', fontSize: '0.72rem', color: '#ffffff' }}
                                                        className="py-1 px-2 fw-bold shadow-sm"
                                                        onClick={() => handleVisualizarPDFAnexo(idAnx, `${tipoAnx}: ${descAnx}`)}
                                                    >
                                                        👁️ {tipoAnx}: {descAnx}
                                                    </Button>
                                                );
                                            })
                                        ) : (
                                            <Button
                                                size="sm"
                                                style={{ backgroundColor: '#8b0000', borderColor: '#8b0000', fontSize: '0.75rem', color: '#ffffff' }}
                                                className="py-1 px-2 fw-bold shadow-sm"
                                                onClick={() => handleVisualizarPDFContrato(
                                                    lancamentoPendSelecionado?.FINC_ID,
                                                    'Contrato Principal PDF'
                                                )}
                                            >
                                                👁️ Ver PDF do Contrato
                                            </Button>
                                        )}
                                    </div>
                                </div>

                                <p className="mb-1 small"><strong>Departamento:</strong> <Badge style={{ backgroundColor: '#8b0000' }} className="ms-1">{lancamentoPendSelecionado?.FINC_DEPARTAMENTO || 'TI'}</Badge></p>
                                <p className="mb-1 small"><strong>Contrato:</strong> {lancamentoPendSelecionado?.FINC_DESCRICAO}</p>
                                <p className="mb-1 small"><strong>Fornecedor:</strong> {lancamentoPendSelecionado?.FINC_FORNECEDOR}</p>
                                <p className="mb-2 small"><strong>Valor Total Consolidado:</strong> <span className="fs-5 fw-bold text-danger ms-1">{formatarMoedaBR(lancamentoPendSelecionado?.FINL_VALOR_TOTAL)}</span></p>

                                {lancamentoPendSelecionado?.FINL_OBSERVACAO && (
                                    <div className="alert alert-warning p-2 small rounded-2 mb-3">
                                        <strong>Justificativa de Alteração / Dólar / Reajuste:</strong><br />
                                        {lancamentoPendSelecionado?.FINL_OBSERVACAO}
                                    </div>
                                )}

                                <h6 className="fw-bold text-dark mt-2 mb-2">Notas Fiscais Vinculadas a este Lançamento</h6>
                                <Table responsive striped bordered hover size="sm" className="small align-middle mb-0">
                                    <thead className="table-light">
                                        <tr>
                                            <th>Tipo</th>
                                            <th>Nº Nota</th>
                                            <th>Loja</th>
                                            <th>Vencimento</th>
                                            <th>Valor</th>
                                            <th className="text-center">PDF</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {notasDoLancamento.map((nf, idx) => (
                                            <tr key={idx}>
                                                <td><Badge bg="secondary">{nf.FINN_TIPO_NOTA}</Badge></td>
                                                <td className="fw-bold">{nf.FINN_NUMERO}</td>
                                                <td>Loja {nf.FINN_COD_EMP}</td>
                                                <td>{nf.FINN_DATA_VENCIMENTO}</td>
                                                <td>{formatarMoedaBR(nf.FINN_VALOR)}</td>
                                                <td className="text-center">
                                                    <Button
                                                        size="sm"
                                                        variant="outline-danger"
                                                        className="py-0 px-2"
                                                        style={{ fontSize: '0.7rem' }}
                                                        onClick={() => handleVisualizarPDFNota(nf.FINN_ID, `Visualizar NF ${nf.FINN_NUMERO}`)}
                                                    >
                                                        👁️ Ver PDF
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </Card>
                        </Col>

                        <Col md={5}>
                            <Card className="h-100 border-0 shadow-sm rounded-3 p-3 bg-white">
                                <h6 className="fw-bold text-dark mb-3">Histórico das Últimas 12 Competências</h6>
                                <div style={{ maxHeight: '350px', overflowY: 'auto' }}>
                                    <Table striped bordered hover size="sm" className="small align-middle mb-0">
                                        <thead className="table-light">
                                            <tr>
                                                <th>Mês/Ano</th>
                                                <th>Total Mês</th>
                                                <th>Qtd. NFs</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {historico12.map((h, index) => (
                                                <tr key={index}>
                                                    <td className="fw-bold">{h.FINL_COMPETENCIA}</td>
                                                    <td>{formatarMoedaBR(h.FINL_VALOR_TOTAL)}</td>
                                                    <td>{h.QTD_NOTAS || 1} NF(s)</td>
                                                    <td>
                                                        <Badge bg={String(h.FINL_STATUS || '').trim().toUpperCase() === 'APROVADO' ? 'success' : 'warning'}>
                                                            {h.FINL_STATUS}
                                                        </Badge>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </div>
                            </Card>
                        </Col>
                    </Row>

                    {isLancamentoPendente && (
                        <Card className="p-3 border-danger bg-white shadow-sm rounded-3 mb-2">
                            <Form.Group className="mb-2">
                                <Form.Label className="small fw-bold text-secondary">Observações / Ressalvas / Motivo de Negação</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={2}
                                    placeholder="Adicione um comentário ou a justificativa necessária para o criador..."
                                    value={obsAprovacao}
                                    onChange={(e) => setObsAprovacao(e.target.value)}
                                />
                            </Form.Group>

                            <Form.Group className="mt-3">
                                <Form.Label className="small fw-bold text-danger">
                                    🔄 Solicitar Segunda Assinatura / Transferir para Outro Diretor (Opcional)
                                </Form.Label>
                                <InputGroup size="sm">
                                    <Form.Control
                                        placeholder="Digite a Chapa/Matrícula do Diretor/Autorizador adicional..."
                                        value={chapaOutroAutorizador}
                                        onChange={(e) => setChapaOutroAutorizador(e.target.value)}
                                    />
                                    <Button
                                        variant="outline-danger"
                                        className="fw-bold"
                                        onClick={() => handleAprovarRejeitar('SOLICITAR_OUTRA')}
                                    >
                                        👉 Encaminhar Assinatura
                                    </Button>
                                </InputGroup>
                                <small className="text-muted d-block mt-1" style={{ fontSize: '0.72rem' }}>
                                    Ao encaminhar, uma linha de recusa será gerada no seu nome e o processo irá para o diretor informado. Após a assinatura dele, o processo retornará para sua aprovação final.
                                </small>
                            </Form.Group>
                        </Card>
                    )}
                </Modal.Body>
                <Modal.Footer className="bg-white border-top-0 py-2 px-3 d-flex justify-content-between">
                    {isLancamentoPendente ? (
                        <>
                            <Button variant="danger" size="sm" className="fw-bold" onClick={() => handleAprovarRejeitar('REJEITADO')}>❌ Negar / Devolver ao Criador</Button>
                            <div>
                                <Button variant="secondary" size="sm" className="me-2 fw-semibold" onClick={() => setShowModalAprovar(false)}>Cancelar</Button>
                                <Button style={{ backgroundColor: '#8b0000', borderColor: '#8b0000', color: '#ffffff' }} size="sm" className="fw-bold px-3" onClick={() => handleAprovarRejeitar('APROVADO')}>✍️ Assinar & Aprovar</Button>
                            </div>
                        </>
                    ) : (
                        <div className="w-100 d-flex justify-content-between align-items-center">
                            <Badge bg={todasAlcadasAprovadas || statusGeralRegistro === 'APROVADO' ? 'success' : 'danger'} className="p-2 fs-6 rounded-2">
                                Status Final: {todasAlcadasAprovadas ? 'APROVADO' : statusGeralRegistro}
                            </Badge>
                            <Button variant="secondary" size="sm" className="fw-semibold" onClick={() => setShowModalAprovar(false)}>Fechar</Button>
                        </div>
                    )}
                </Modal.Footer>
            </Modal>

            {/* MODAL LANÇAR COMPETÊNCIA */}
            <Modal show={showModalLancarCompetencia} onHide={() => setShowModalLancarCompetencia(false)} size="xl" centered scrollable>
                <Form onSubmit={handleSalvarLancamentoCompetencia}>
                    <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #8b0000 0%, #a91b0d 50%, #c0392b 100%)', color: '#ffffff' }} className="py-2 px-3 border-0">
                        <Modal.Title className="fs-6 fw-bold text-white">
                            Lançar Ficha da Competência - [{contratoSelecionado?.FINC_DEPARTAMENTO || 'TI'}] {contratoSelecionado?.FINC_DESCRICAO}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="bg-light p-3">
                        <Card className="p-3 border-0 shadow-sm rounded-3 mb-3 bg-white">
                            <Row className="g-3 align-items-center">
                                <Col md={3}>
                                    <Form.Label className="small fw-bold text-secondary mb-1">Mês / Ano (Competência)</Form.Label>
                                    <Form.Control
                                        required
                                        size="sm"
                                        placeholder="Ex: 08/2026"
                                        value={formLancamento.finl_competencia}
                                        onChange={(e) => setFormLancamento({ ...formLancamento, finl_competencia: e.target.value })}
                                    />
                                </Col>
                                <Col md={4}>
                                    <Form.Label className="small fw-bold text-secondary mb-1">Valor Mês Anterior (Referência)</Form.Label>
                                    <Form.Control
                                        disabled
                                        size="sm"
                                        readOnly
                                        className="bg-light"
                                        value={formatarMoedaBR(formLancamento.finl_valor_anterior)}
                                    />
                                </Col>
                                <Col md={5}>
                                    <Form.Label className="small fw-bold text-secondary mb-1">Soma Total das NFs do Mês</Form.Label>
                                    <Form.Control
                                        disabled
                                        readOnly
                                        size="sm"
                                        className="fw-bold text-danger fs-5 bg-light"
                                        value={formLancamento.finl_valor_total}
                                    />
                                </Col>
                            </Row>
                        </Card>

                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h6 className="fw-bold text-dark mb-0">Notas Fiscais do Mês</h6>
                            <Button size="sm" variant="outline-danger" className="fw-bold d-flex align-items-center gap-1" onClick={handleAdicionarNotaLinha}>
                                <FaPlus size={10} /> Adicionar Outra Nota Fiscal
                            </Button>
                        </div>

                        {formLancamento.notas.map((nota, idx) => (
                            <Card key={idx} className="mb-2 p-3 border-0 bg-white shadow-sm rounded-3">
                                <Row className="g-2 align-items-center">
                                    <Col md={2}>
                                        <Form.Label className="small fw-bold text-secondary mb-1">Tipo Nota</Form.Label>
                                        <Form.Select
                                            size="sm"
                                            value={nota.finn_tipo_nota}
                                            onChange={(e) => handleUpdateNotaLinha(idx, "finn_tipo_nota", e.target.value)}
                                        >
                                            <option value="SERVICO">Serviço (NFS-e)</option>
                                            <option value="PRODUTO">Produto / Danfe</option>
                                            <option value="OUTROS">Outros</option>
                                        </Form.Select>
                                    </Col>
                                    <Col md={2}>
                                        <Form.Label className="small fw-bold text-secondary mb-1">Loja / Filial</Form.Label>
                                        <Form.Control
                                            size="sm"
                                            type="number"
                                            required
                                            value={nota.finn_cod_emp}
                                            onChange={(e) => handleUpdateNotaLinha(idx, "finn_cod_emp", e.target.value)}
                                        />
                                    </Col>
                                    <Col md={2}>
                                        <Form.Label className="small fw-bold text-secondary mb-1">Nº Nota Fiscal</Form.Label>
                                        <Form.Control
                                            size="sm"
                                            required
                                            value={nota.finn_numero}
                                            onChange={(e) => handleUpdateNotaLinha(idx, "finn_numero", e.target.value)}
                                        />
                                    </Col>
                                    <Col md={2}>
                                        <Form.Label className="small fw-bold text-secondary mb-1">Data Emissão</Form.Label>
                                        <Form.Control
                                            size="sm"
                                            type="date"
                                            required
                                            value={nota.finn_data_emissao}
                                            onChange={(e) => handleUpdateNotaLinha(idx, "finn_data_emissao", e.target.value)}
                                        />
                                    </Col>
                                    <Col md={2}>
                                        <Form.Label className="small fw-bold text-secondary mb-1">Vencimento</Form.Label>
                                        <Form.Control
                                            size="sm"
                                            type="date"
                                            required
                                            value={nota.finn_data_vencimento}
                                            onChange={(e) => handleUpdateNotaLinha(idx, "finn_data_vencimento", e.target.value)}
                                        />
                                    </Col>
                                    <Col md={2}>
                                        <Form.Label className="small fw-bold text-secondary mb-1">Valor Nota (R$)</Form.Label>
                                        <Form.Control
                                            size="sm"
                                            type="text"
                                            required
                                            value={nota.finn_valor}
                                            onChange={(e) => handleUpdateNotaLinha(idx, "finn_valor", aplicarMascaraMoeda(e.target.value))}
                                        />
                                    </Col>
                                    <Col md={10}>
                                        <Form.Label className="small fw-bold text-secondary mb-1">Anexar PDF da Nota</Form.Label>
                                        <Form.Control
                                            size="sm"
                                            type="file"
                                            accept=".pdf"
                                            onChange={(e) => handleUpdateNotaLinha(idx, "arq_nota", e.target.files[0])}
                                        />
                                    </Col>
                                    <Col md={2} className="text-end mt-4">
                                        <Button
                                            size="sm"
                                            variant="outline-danger"
                                            className="w-100 fw-semibold"
                                            onClick={() => handleRemoverNotaLinha(idx)}
                                        >
                                            <FaTrash size={12} className="me-1" /> Excluir NF
                                        </Button>
                                    </Col>
                                </Row>
                            </Card>
                        ))}

                        <Card className="p-3 border-0 bg-white shadow-sm rounded-3 mt-3">
                            <Form.Group>
                                <Form.Label className="small fw-bold text-secondary mb-1">Observação / Justificativa em Caso de Diferença de Valor</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={2}
                                    placeholder="Descreva o motivo se a soma do mês for diferente do mês anterior..."
                                    value={formLancamento.finl_observacao}
                                    onChange={(e) => setFormLancamento({ ...formLancamento, finl_observacao: e.target.value })}
                                />
                            </Form.Group>
                        </Card>
                    </Modal.Body>
                    <Modal.Footer className="bg-white border-top-0 py-2 px-3">
                        <Button variant="secondary" size="sm" className="fw-semibold" onClick={() => setShowModalLancarCompetencia(false)}>Cancelar</Button>
                        <Button style={{ backgroundColor: '#8b0000', borderColor: '#8b0000', color: '#ffffff' }} size="sm" type="submit" className="fw-bold px-3">ENVIAR COMPETÊNCIA PARA APROVAÇÃO</Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            {/* MODAL CADASTRAR / EDITAR CONTRATO */}
            <Modal show={showModalNovoContrato} onHide={() => setShowModalNovoContrato(false)} size="lg" centered scrollable>
                <Form onSubmit={handleSalvarContrato}>
                    <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #8b0000 0%, #a91b0d 50%, #c0392b 100%)', color: '#ffffff' }} className="py-2 px-3 border-0">
                        <Modal.Title className="fs-6 fw-bold text-white">
                            {isEdicaoContrato ? `Editar Contrato nº ${formContrato.finc_id}` : 'Cadastrar Novo Contrato'}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="p-3 bg-light">
                        <Card className="p-3 border-0 shadow-sm rounded-3 mb-3 bg-white">
                            <Row className="g-2 mb-2">
                                <Col md={6}>
                                    <Form.Label className="small fw-bold text-secondary mb-1">Descrição do Contrato</Form.Label>
                                    <Form.Control
                                        required
                                        size="sm"
                                        placeholder="Ex: CloudPark Sistemas de Automação"
                                        value={formContrato.finc_descricao}
                                        onChange={(e) => setFormContrato({ ...formContrato, finc_descricao: e.target.value })}
                                    />
                                </Col>
                                <Col md={6}>
                                    <Form.Label className="small fw-bold text-secondary mb-1">Fornecedor / Razão Social</Form.Label>
                                    <Form.Control
                                        required
                                        size="sm"
                                        placeholder="Ex: CloudPark Sistemas Ltda"
                                        value={formContrato.finc_fornecedor}
                                        onChange={(e) => setFormContrato({ ...formContrato, finc_fornecedor: e.target.value })}
                                    />
                                </Col>
                            </Row>

                            <Row className="g-2 mb-2">
                                <Col md={4}>
                                    <Form.Label className="small fw-bold text-secondary mb-1">Departamento Responsável</Form.Label>
                                    <Form.Select
                                        size="sm"
                                        value={formContrato.finc_departamento}
                                        onChange={(e) => setFormContrato({ ...formContrato, finc_departamento: e.target.value })}
                                    >
                                        {LISTA_DEPARTAMENTOS.map(d => (
                                            <option key={d} value={d}>{d}</option>
                                        ))}
                                    </Form.Select>
                                </Col>
                                <Col md={4}>
                                    <Form.Label className="small fw-bold text-secondary mb-1">Abrangência / Loja</Form.Label>
                                    <Form.Select
                                        size="sm"
                                        value={formContrato.finc_tipo_abrangencia}
                                        onChange={(e) => setFormContrato({ ...formContrato, finc_tipo_abrangencia: e.target.value })}
                                    >
                                        <option value="FILIAL">Filial Específica</option>
                                        <option value="GLOBAL">GLOBAL (Todas Filiais)</option>
                                    </Form.Select>
                                </Col>
                                {formContrato.finc_tipo_abrangencia.includes("FILIAL") && (
                                    <Col md={4}>
                                        <Form.Label className="small fw-bold text-secondary mb-1">Código da Loja</Form.Label>
                                        <Form.Control
                                            type="number"
                                            size="sm"
                                            value={formContrato.finc_cod_emp}
                                            onChange={(e) => setFormContrato({ ...formContrato, finc_cod_emp: e.target.value })}
                                        />
                                    </Col>
                                )}
                            </Row>

                            <Row className="g-2 mb-2">
                                <Col md={6}>
                                    <Form.Label className="small fw-bold text-secondary mb-1">Índice Reajuste</Form.Label>
                                    <Form.Select
                                        size="sm"
                                        value={formContrato.finc_indice_reajuste}
                                        onChange={(e) => setFormContrato({ ...formContrato, finc_indice_reajuste: e.target.value })}
                                    >
                                        <option value="IGPM">IGP-M</option>
                                        <option value="IPCA">IPCA</option>
                                        <option value="DOLAR">DÓLAR</option>
                                        <option value="FIXO">FIXO</option>
                                    </Form.Select>
                                </Col>
                                <Col md={6}>
                                    <Form.Label className="small fw-bold text-secondary mb-1">Dia Vencimento</Form.Label>
                                    <Form.Control
                                        type="number"
                                        size="sm"
                                        min="1"
                                        max="31"
                                        placeholder="Ex: 10"
                                        value={formContrato.finc_dia_vencimento || ''}
                                        onChange={(e) => setFormContrato({ ...formContrato, finc_dia_vencimento: e.target.value })}
                                    />
                                </Col>
                            </Row>

                            <Row className="g-2 mb-2">
                                <Col md={3}>
                                    <Form.Label className="small fw-bold text-secondary mb-1">Data Início</Form.Label>
                                    <Form.Control
                                        type="date"
                                        size="sm"
                                        required
                                        value={formContrato.finc_data_inicio}
                                        onChange={(e) => {
                                            const dtIni = e.target.value;
                                            const dtFim = calcularDataFim(dtIni, formContrato.tempo_meses);
                                            setFormContrato({
                                                ...formContrato,
                                                finc_data_inicio: dtIni,
                                                finc_data_fim: dtFim || formContrato.finc_data_fim
                                            });
                                        }}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Form.Label className="small fw-bold text-secondary mb-1">Duração (Meses)</Form.Label>
                                    <Form.Control
                                        type="number"
                                        size="sm"
                                        min="1"
                                        placeholder="Ex: 24"
                                        value={formContrato.tempo_meses || ''}
                                        onChange={(e) => {
                                            const meses = e.target.value;
                                            const dtFim = calcularDataFim(formContrato.finc_data_inicio, meses);
                                            setFormContrato({
                                                ...formContrato,
                                                tempo_meses: meses,
                                                finc_data_fim: dtFim || formContrato.finc_data_fim
                                            });
                                        }}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Form.Label className="small fw-bold text-secondary mb-1">Data Fim (Calculada)</Form.Label>
                                    <Form.Control
                                        type="date"
                                        size="sm"
                                        value={formContrato.finc_data_fim}
                                        onChange={(e) => setFormContrato({ ...formContrato, finc_data_fim: e.target.value })}
                                    />
                                </Col>
                                <Col md={3}>
                                    <Form.Label className="small fw-bold text-secondary mb-1">Valor Base (R$)</Form.Label>
                                    <Form.Control
                                        type="text"
                                        size="sm"
                                        value={formContrato.finc_valor_base}
                                        onChange={(e) => setFormContrato({ ...formContrato, finc_valor_base: aplicarMascaraMoeda(e.target.value) })}
                                    />
                                </Col>
                            </Row>

                            {isEdicaoContrato && anexosModalEdicao.length > 0 && (
                                <Card className="mb-2 border-danger-subtle bg-danger-subtle p-2 rounded-3">
                                    <div className="fw-bold small text-danger mb-2">
                                        📎 Anexos e Adendos Salvos ({anexosModalEdicao.length})
                                    </div>
                                    <Table size="sm" borderless className="mb-0 align-middle extra-small bg-white rounded-2">
                                        <tbody>
                                            {anexosModalEdicao.map((anx, aIdx) => {
                                                const anxId = anx.FINA_ID;
                                                const anxTipo = anx.FINA_TIPO || "ANEXO";
                                                const anxNome = anx.FINA_NOME_ARQ || "documento.pdf";
                                                const anxDesc = anx.FINA_DESCRICAO || "";

                                                return (
                                                    <tr key={aIdx} className="border-bottom">
                                                        <td className="px-2 py-1">
                                                            <Badge bg={anxTipo === 'CONTRATO' ? 'danger' : 'warning'} className="me-2">
                                                                {anxTipo}
                                                            </Badge>
                                                            <strong>{anxNome}</strong> {anxDesc && <span className="text-muted">({anxDesc})</span>}
                                                        </td>
                                                        <td className="text-end px-2 py-1">
                                                            <Button
                                                                size="sm"
                                                                variant="outline-danger"
                                                                className="py-0 px-2 fw-bold"
                                                                onClick={() => handleVisualizarPDFAnexo(anxId, `${anxTipo}: ${anxNome}`)}
                                                            >
                                                                👁️ Visualizar
                                                            </Button>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </Table>
                                </Card>
                            )}

                            <Form.Group className="mb-1">
                                <Form.Label className="small fw-bold text-secondary mb-1">
                                    {isEdicaoContrato ? "Substituir PDF do Contrato Principal (Opcional)" : "PDF do Contrato Principal"}
                                </Form.Label>
                                <Form.Control
                                    type="file"
                                    size="sm"
                                    accept=".pdf"
                                    onChange={(e) => setFormContrato({ ...formContrato, arq_contrato: e.target.files[0] })}
                                />
                            </Form.Group>
                        </Card>

                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h6 className="fw-bold text-dark mb-0">Alçadas Sequenciais de Assinatura</h6>
                            <small className="text-muted">Informe a chapa para buscar o colaborador</small>
                        </div>

                        {alcadas.map((alc, idx) => (
                            <Card key={idx} className="mb-2 p-2 bg-white border-0 shadow-sm rounded-3">
                                <Row className="g-2 align-items-center">
                                    <Col md={1} className="fw-bold text-center text-danger fs-6">
                                        #{idx + 1}
                                    </Col>
                                    <Col md={3}>
                                        <Form.Label className="small fw-bold text-secondary mb-1">Matrícula / Chapa</Form.Label>
                                        <Form.Control
                                            required
                                            size="sm"
                                            placeholder="Ex: 051118"
                                            value={alc.matricula}
                                            onChange={(e) => {
                                                const newAlc = [...alcadas];
                                                newAlc[idx].matricula = e.target.value;
                                                newAlc[idx].nome = "";
                                                setAlcadas(newAlc);
                                            }}
                                            onBlur={(e) => handleBuscarAprovador(idx, e.target.value)}
                                        />
                                    </Col>
                                    <Col md={4}>
                                        <Form.Label className="small fw-bold text-secondary mb-1">Nome Aprovador</Form.Label>
                                        <Form.Control
                                            readOnly
                                            size="sm"
                                            disabled
                                            className="bg-light fw-bold text-dark"
                                            placeholder="Aguardando chapa..."
                                            value={alc.nome}
                                        />
                                    </Col>
                                    <Col md={3}>
                                        <Form.Label className="small fw-bold text-secondary mb-1">Cargo / Função</Form.Label>
                                        <Form.Control
                                            required
                                            size="sm"
                                            placeholder="Ex: GERENTE, DIRETOR"
                                            value={alc.cargo}
                                            onChange={(e) => {
                                                const newAlc = [...alcadas];
                                                newAlc[idx].cargo = e.target.value;
                                                setAlcadas(newAlc);
                                            }}
                                        />
                                    </Col>
                                    <Col md={1} className="text-center mt-3">
                                        <Button
                                            size="sm"
                                            variant="outline-danger"
                                            className="py-0 px-2"
                                            title="Excluir Alçada"
                                            onClick={() => handleRemoverAlcada(idx)}
                                        >
                                            <FaTrash size={12} />
                                        </Button>
                                    </Col>
                                </Row>
                            </Card>
                        ))}

                        <Button
                            size="sm"
                            variant="outline-danger"
                            className="mt-2 fw-bold d-flex align-items-center gap-1"
                            onClick={handleAdicionarAlcada}
                        >
                            <FaPlus size={10} /> Adicionar Alçada de Assinatura
                        </Button>
                    </Modal.Body>
                    <Modal.Footer className="bg-white border-top-0 py-2 px-3">
                        <Button variant="secondary" size="sm" className="fw-semibold" onClick={() => setShowModalNovoContrato(false)}>Cancelar</Button>
                        <Button style={{ backgroundColor: '#8b0000', borderColor: '#8b0000', color: '#ffffff' }} size="sm" type="submit" className="fw-bold px-3">
                            {isEdicaoContrato ? "Salvar Alterações" : "Cadastrar Contrato"}
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            {/* MODAL NOVO ANEXO */}
            <Modal show={showModalNovoAnexo} onHide={() => setShowModalNovoAnexo(false)} centered>
                <Form onSubmit={handleSalvarAnexo}>
                    <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #8b0000 0%, #a91b0d 50%, #c0392b 100%)', color: '#ffffff' }} className="py-2 px-3 border-0">
                        <Modal.Title className="fs-6 fw-bold d-flex align-items-center gap-2 text-white">
                            <FaPaperclip /> Anexar Adendo / Reajuste ao Contrato
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="bg-light p-3">
                        <Card className="p-3 border-0 shadow-sm rounded-3 bg-white">
                            <Form.Group className="mb-3">
                                <Form.Label className="small fw-bold text-secondary">Tipo de Anexo</Form.Label>
                                <Form.Select
                                    size="sm"
                                    value={formAnexo.fina_tipo}
                                    onChange={(e) => setFormAnexo({ ...formAnexo, fina_tipo: e.target.value })}
                                >
                                    <option value="ADENDO">Adendo Contratual</option>
                                    <option value="REAJUSTE">Reajuste de Tarifa / Índice</option>
                                    <option value="TERMO_ADITIVO">Termo Aditivo</option>
                                    <option value="OUTROS">Outros Documentos</option>
                                </Form.Select>
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label className="small fw-bold text-secondary">Descrição / Observação do Adendo</Form.Label>
                                <Form.Control
                                    required
                                    size="sm"
                                    placeholder="Ex: Adendo do reajuste de IPCA (+4,5%)"
                                    value={formAnexo.fina_descricao}
                                    onChange={(e) => setFormAnexo({ ...formAnexo, fina_descricao: e.target.value })}
                                />
                            </Form.Group>

                            <Form.Group className="mb-1">
                                <Form.Label className="small fw-bold text-secondary">Selecione o Arquivo PDF</Form.Label>
                                <Form.Control
                                    type="file"
                                    size="sm"
                                    required
                                    accept=".pdf"
                                    onChange={(e) => setFormAnexo({ ...formAnexo, arq_anexo: e.target.files[0] })}
                                />
                            </Form.Group>
                        </Card>
                    </Modal.Body>
                    <Modal.Footer className="bg-white border-top-0 py-2 px-3">
                        <Button variant="secondary" size="sm" className="fw-semibold" onClick={() => setShowModalNovoAnexo(false)}>Cancelar</Button>
                        <Button style={{ backgroundColor: '#8b0000', borderColor: '#8b0000', color: '#ffffff' }} size="sm" type="submit" className="fw-bold px-3">Salvar Anexo</Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            {/* MODAL LOGS DO CONTRATO */}
            <Modal show={showModalLogs} onHide={() => setShowModalLogs(false)} size="lg" centered scrollable>
                <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #8b0000 0%, #a91b0d 50%, #c0392b 100%)', color: '#ffffff' }} className="py-2 px-3 border-0">
                    <Modal.Title className="fs-6 fw-bold text-white">📜 Histórico e Logs de Alteração do Contrato</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0">
                    <Table responsive hover className="mb-0 align-middle small">
                        <thead className="table-light">
                            <tr>
                                <th className="px-3">Data/Hora</th>
                                <th>Ação / Status</th>
                                <th>Usuário Responsável</th>
                                <th className="px-3">Observação / Detalhes</th>
                            </tr>
                        </thead>
                        <tbody>
                            {!logsContrato || logsContrato.length === 0 ? (
                                <tr>
                                    <td colSpan="4" className="text-center py-4 text-muted">
                                        Nenhum log gravado para este contrato.
                                    </td>
                                </tr>
                            ) : (
                                logsContrato.map((log, i) => {
                                    const dataHora = log.FINCL_DATAHORA || log.DATAHORA || '-';
                                    const status = log.FINCL_STATUS || log.STATUS || '-';
                                    const usuario = log.FINCL_USUARIOLOGADO || log.USUARIOLOGADO || '-';
                                    const observacao = log.FINCL_OBSERVACAO || log.OBSERVACAO || '-';

                                    return (
                                        <tr key={i}>
                                            <td className="px-3" style={{ whiteSpace: 'nowrap' }}>{dataHora}</td>
                                            <td><Badge style={{ backgroundColor: '#8b0000' }}>{status}</Badge></td>
                                            <td>{usuario}</td>
                                            <td className="px-3 text-secondary">{observacao}</td>
                                        </tr>
                                    );
                                })
                            )}
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer className="bg-white border-top-0 py-2 px-3">
                    <Button variant="secondary" size="sm" className="fw-semibold" onClick={() => setShowModalLogs(false)}>Fechar</Button>
                </Modal.Footer>
            </Modal>

            {/* MODAL VISUALIZADOR DE PDF */}
            <Modal show={showModalPDF} onHide={() => setShowModalPDF(false)} size="lg" centered style={{ zIndex: 1080 }}>
                <Modal.Header closeButton className="bg-dark text-white py-2 px-3">
                    <Modal.Title className="fs-6 fw-bold d-flex align-items-center gap-2">
                        <FaFilePdf /> {tituloPdfView}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0" style={{ height: '75vh' }}>
                    <iframe src={urlPdfView} title="PDF Viewer" width="100%" height="100%" style={{ border: 'none' }} />
                </Modal.Body>
            </Modal>

            {/* SPINNER GLOBAL */}
            <Modal show={loading} backdrop="static" keyboard={false} centered size="sm" contentClassName="bg-transparent border-0">
                <Modal.Body className="text-center">
                    <Spinner animation="border" variant="light" style={{ width: '3rem', height: '3rem' }} />
                    <div className="text-light mt-2 fw-bold">Carregando...</div>
                </Modal.Body>
            </Modal>

            <Footer />
        </div>
    );
}

export default FichaFinanceira;